{
	"dialog.ok": "OK",
	"dialog.cancel": "Huỷ bỏ",
	"dialog.confirm": "Xác nhận",
	"dialog.close": "Đóng",
	"dialog.import": "Nhập",
	"dialog.save": "Lưu",
	"dialog.discard": "Bỏ qua",
	"dialog.dontshowagain": "Không hiển thị lại",
	"data.cube": "Khối",
	"data.group": "Nhóm",
	"data.texture": "Texture",
	"data.plugin": "Plugin",
	"data.preview": "Xem trước",
	"data.toolbar": "Thanh công cụ",
	"data.image": "Hình ảnh",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Xoá",
	"keys.space": "Phím cách",
	"keys.leftclick": "Chuột trái",
	"keys.middleclick": "Nút giữa",
	"keys.rightclick": "Chuột phải",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "Phím số %0",
	"keys.caps": "Capslock",
	"keys.menu": "Menu ngữ cảnh",
	"keys.left": "Trái",
	"keys.up": "Trên",
	"keys.right": "Phải",
	"keys.down": "Dưới",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Cộng",
	"keys.comma": "Phẩy",
	"keys.point": "Chấm",
	"keys.minus": "Trừ",
	"keys.cross": "Nút chéo",
	"keys.end": "End",
	"keys.pos1": "Home",
	"keys.printscreen": "In màn hình",
	"keys.pause": "Dừng",
	"message.rotation_limit.title": "Giới hạn quay",
	"message.rotation_limit.message": "Việc quay bị Minecraft giới hạn về một trục. Nếu quay trên một trục khác sẽ xóa hết tất cả sự quay hiện có ở các trục khác. Hãy chuyển đổi mô hình thành \"Mô hình tự do\" nếu bạn đang tạo mô hình cho các mục đích khác và cần sự quay tự do.",
	"message.file_not_found.title": "Không tìm thấy Tệp",
	"message.file_not_found.message": "Blockbench không thể tìm được tệp được yêu cầu. Hãy đảm bảo rằng nó được lưu trên máy và không phải trong hệ thống cloud.",
	"message.screenshot.title": "Chụp ảnh màn hình",
	"message.screenshot.clipboard": "Bảng tạm",
	"message.screenshot.right_click": "Nhấn chuột phải hoặc nhấn giữ ảnh để sao chép",
	"message.invalid_file.title": "Tệp không hợp lệ",
	"message.invalid_file.message": "Không thể mở tệp json: %0",
	"message.invalid_model.title": "Tệp Mô hình không hợp lệ",
	"message.invalid_model.message": "Tệp này không chứa dữ liệu mô hình hợp lệ",
	"message.child_model_only.title": "Mô hình con rỗng",
	"message.child_model_only.message": "Đây là một tệp con của %0 và không chứa mô hình nào",
	"message.unsaved_textures.title": "Texture chưa được lưu",
	"message.unsaved_textures.message": "Mô hình của bạn còn có những Texture chưa được lưu. Hãy đảm bảo việc lưu chúng và đưa chúng vào tập tài nguyên của bạn trong đúng thư mục.",
	"message.model_clipping.title": "Mô hình quá lớn",
	"message.model_clipping.message": "Mô hình của bạn bao gồm %0 khối lớn hơn giới hạn kích thước khối cho phép của Minecraft. Mô hình này sẽ không sử dụng được trong Minecraft.",
	"message.loose_texture.title": "Nhập texture",
	"message.loose_texture.message": "Texture được nhập không nằm trong một resource pack. Minecraft chỉ có thể tải những texture trong thư mục “textures” của một resource pack.",
	"message.loose_texture.change": "Thay đổi đường dẫn",
	"message.update_res.title": "Độ phân giải của texture",
	"message.update_res.message": "Bạn có muốn cập nhật độ phân giải của toàn dự án về độ phân giải của texture này không? Bấm 'Hủy bỏ' nếu texture của bạn có một độ phân giải chất lượng hơn cả bình thường.",
	"message.update_res.update": "Cập nhật",
	"message.bedrock_overwrite_error.message": "Blockbench không thể kết hợp mô hình này với tệp cũ",
	"message.bedrock_overwrite_error.backup_overwrite": "Tạo Sao lưu và Lưu đè",
	"message.bedrock_overwrite_error.overwrite": "Lưu đè",
	"message.close_warning.message": "Bạn có muốn lưu mô hình này không?",
	"message.close_warning.web": "Mô hình hiện tại của bạn đang làm dở sẽ bị mất. Bạn có chắc chắn là bạn muốn thoát không?",
	"message.default_textures.title": "Texture mặc định",
	"message.default_textures.message": "Chọn thư mục \"texture\" của Resource pack mặc định",
	"message.default_textures.detail": "Giải nén Resource pack mặc định từ tệp jar của Minecraft hoặc tìm và tải xuống. Rồi tìm thư mục \"textures\" và mở nó ra. Blockbench sẽ ghi nhớ vị trí đó và cố gắng lấy Texture từ đó nếu không tìm thấy được chúng trong Resource pack hiện đang sử dụng.",
	"message.default_textures.select": "Chọn thư mục \"textures\" mặc định",
	"message.image_editor.title": "Chọn một phần mềm chỉnh sửa hình ảnh",
	"message.image_editor.file": "Chọn tệp...",
	"message.image_editor.exe": "Chọn tệp exe của phần mềm chỉnh sửa hình ảnh",
	"message.display_skin.title": "Skin Minecraft",
	"message.display_skin.message": "Chọn một tệp skin từ máy tính của bạn hoặc nhập một tên người chơi",
	"message.display_skin.upload": "Chọn tệp",
	"message.display_skin.reset": "Đặt lại",
	"message.invalid_plugin": "Tệp Plugin không hợp lệ, xem Bảng điều khiển",
	"message.load_plugin_app": "Bạn có muốn cho phép plugin này thực hiện thay đổi trên máy tính bạn không? Chỉ nên tải những plugin từ những người mà bạn tin tưởng.",
	"message.load_plugin_web": "Bạn có muốn tải plugin này không? Chỉ nên tải những plugin từ những người mà bạn tin tưởng.",
	"message.preset_no_info": "Giá trị cài sẵn không chứa thông tin cho khe này",
	"message.restart_to_update": "Khởi động lại Blockbench để áp dụng những thay đổi",
	"message.save_file": "Lưu dưới dạng %0",
	"dialog.project.title": "Dự án",
	"dialog.project.name": "Tên tệp",
	"dialog.project.parent": "Mô hình cha",
	"dialog.project.geoname": "Định danh mô hình",
	"dialog.project.ao": "Che khuất môi trường (AO)",
	"dialog.texture.title": "Texture",
	"dialog.texture.variable": "Biến số",
	"dialog.texture.namespace": "Không gian tên",
	"dialog.texture.folder": "Thư mục",
	"dialog.extrude.title": "Tạo khối từ ảnh",
	"dialog.extrude.mode": "Chế độ quét",
	"dialog.extrude.mode.areas": "Diện tích",
	"dialog.extrude.mode.lines": "Đường thẳng",
	"dialog.extrude.mode.columns": "Cột",
	"dialog.extrude.mode.pixels": "Điểm ảnh",
	"dialog.extrude.opacity": "Độ trong suốt tối thiểu",
	"dialog.extrude.scan": "Quét và nhập",
	"dialog.display_preset.title": "Tạo giá trị cài sẵn",
	"dialog.display_preset.message": "Chọn các vị trí bạn muốn lưu",
	"dialog.display_preset.create": "Tạo",
	"dialog.select.title": "Chọn",
	"dialog.select.group": "Trong nhóm đã chọn",
	"dialog.select.name": "Tên có chứa",
	"dialog.select.random": "Tỷ lệ ngẫu nhiên (%)",
	"dialog.select.select": "Lựa chọn",
	"dialog.scale.title": "Chỉnh kích cỡ mô hình",
	"dialog.scale.axis": "Trục",
	"dialog.scale.clipping": "Vượt giới hạn mô hình: Mô hình của bạn quá lớn so với không gian làm việc.",
	"dialog.scale.confirm": "Áp dụng tỷ lệ",
	"dialog.plugins.title": "Plugin",
	"dialog.plugins.installed": "Đã cài đặt",
	"dialog.plugins.available": "Có sẵn",
	"dialog.plugins.install": "Cài đặt",
	"dialog.plugins.uninstall": "Gỡ cài đặt",
	"dialog.plugins.reload": "Tải lại",
	"dialog.plugins.none_installed": "Không có Plugin nào được cài đặt",
	"dialog.plugins.none_available": "Không có Plugin nào có sẵn",
	"dialog.plugins.web_only": "Chỉ dùng cho phiên bản trên web",
	"dialog.plugins.app_only": "Chỉ dùng cho phiên bản máy tính",
	"dialog.plugins.author": "bởi %0",
	"dialog.create_texture.folder": "Thư mục",
	"dialog.create_texture.resolution": "Độ phân giải",
	"dialog.input.title": "Đầu vào",
	"dialog.settings.settings": "Cài đặt",
	"dialog.settings.keybinds": "Phím tổ hợp",
	"dialog.settings.about": "Giới thiệu",
	"layout.color.back": "Nền sau",
	"layout.color.back.desc": "Màu nền và các ô nhập liệu",
	"layout.color.dark": "Tối",
	"layout.color.dark.desc": "Nền Không gian làm việc (Canvas)",
	"layout.color.ui": "Giao diện",
	"layout.color.ui.desc": "Màu sắc giao diện chính",
	"layout.color.bright_ui": "Giao diện sáng màu",
	"layout.color.bright_ui.desc": "Menu ngữ cảnh và chú giải công cụ (tooltip)",
	"layout.color.button": "Nút",
	"layout.color.button.desc": "Nút và công tắc",
	"layout.color.selected": "Đã chọn",
	"layout.color.selected.desc": "Các tab và đối tượng đã chọn",
	"layout.color.border": "Đường viền",
	"layout.color.border.desc": "Đường viền của các nút và ô nhập liệu",
	"layout.color.accent": "Màu nhấn",
	"layout.color.accent.desc": "Con trượt và các chi tiết khác",
	"layout.color.grid": "Lưới",
	"layout.color.grid.desc": "Lưới xem trước 3D",
	"layout.color.text": "Màu chữ",
	"layout.color.text.desc": "Màu của chữ thường",
	"layout.color.light": "Sáng",
	"layout.color.light.desc": "Văn bản được làm nổi bật",
	"layout.color.accent_text": "Chữ trên nền nhấn",
	"layout.color.accent_text.desc": "Văn bản trên nền có màu nhấn",
	"layout.font.main": "Phông chữ chính",
	"layout.font.headline": "Phông chữ tiêu đề",
	"about.version": "Phiên bản:",
	"settings.category.general": "Cài đặt chung",
	"settings.category.preview": "Xem trước",
	"settings.category.grid": "Lưới",
	"settings.category.edit": "Chỉnh sửa",
	"settings.category.snapping": "Bắt điểm",
	"settings.category.defaults": "Mặc định",
	"settings.category.dialogs": "Hộp thoại",
	"settings.category.export": "Xuất tệp",
	"settings.language": "Ngôn ngữ",
	"settings.language.desc": "Ngôn ngữ giao diện",
	"settings.backup_interval": "Tần suất sao lưu",
	"settings.backup_interval.desc": "Khoảng thời gian giữa mỗi lần sao lưu tự động, theo phút",
	"settings.origin_size": "Đánh dấu pivot",
	"settings.origin_size.desc": "Kích thước dấu pivot",
	"settings.control_size": "Kích thước gizmo Biến đổi",
	"settings.control_size.desc": "Kích thước của gizmo biến đổi",
	"settings.display_skin": "Hiển thị Skin",
	"settings.display_skin.desc": "Skin dùng cho mô hình người chơi tham chiếu",
	"settings.shading": "Đổ bóng",
	"settings.shading.desc": "Kích hoạt Đổ bóng",
	"settings.base_grid": "Lưới nhỏ",
	"settings.base_grid.desc": "Hiển thị lưới kích cỡ nhỏ và các trục",
	"settings.large_grid": "Lưới khối",
	"settings.large_grid.desc": "Hiển thị lưới kích thước khối 16x16",
	"settings.full_grid": "Lưới khối chính xác",
	"settings.full_grid.desc": "Hiển thị lưới khối chính xác đến từng pixel",
	"settings.large_box": "Hộp giới hạn kích thước",
	"settings.large_box.desc": "Hiển thị các ranh giới hạn kích thước",
	"settings.display_grid": "Lưới trong chế độ hiển thị",
	"settings.display_grid.desc": "Hiển thị lưới trong chế độ hiển thị",
	"settings.undo_limit": "Giới hạn hoàn tác",
	"settings.undo_limit.desc": "Tổng số bước mà bạn có thể hoàn tác",
	"settings.local_move": "Di chuyển trên trục tương đối",
	"settings.local_move.desc": "Di chuyển các phần tử được quay trên trục tương đối của chúng nếu có thể",
	"settings.canvas_unselect": "Bỏ chọn khi nhấp vào nền",
	"settings.canvas_unselect.desc": "Huỷ chọn các phần tử khi nhấp vào nền",
	"settings.paint_side_restrict": "Giới hạn cọ vẽ trên một mặt",
	"settings.paint_side_restrict.desc": "Giới hạn cọ vẽ chỉ tô trên mặt hiện tại",
	"settings.autouv": "UV tự động",
	"settings.autouv.desc": "Kích hoạt UV tự động theo mặc định",
	"settings.create_rename": "Đổi tên khi tạo phần tử mới",
	"settings.create_rename.desc": "Tự động trỏ vào ô tên khi tạo phần tử hoặc nhóm mới",
	"settings.edit_size": "Độ phân giải của lưới",
	"settings.edit_size.desc": "Độ phân giải của lưới mà các phần tử sẽ bắt điểm vào",
	"settings.shift_size": "Độ phân giải (khi giữ Shift)",
	"settings.shift_size.desc": "Độ phân giải của lưới khi giữ phím Shift",
	"settings.ctrl_size": "Độ phân giải (khi giữ Ctrl)",
	"settings.ctrl_size.desc": "Độ phân giải của lưới khi giữ phím Control",
	"settings.negative_size": "Kích cỡ âm",
	"settings.negative_size.desc": "Cho phép công cụ chỉnh sửa kích cỡ sử dụng các kích thước âm",
	"settings.minifiedout": "Xuất tệp gọn",
	"settings.minifiedout.desc": "Thông tin trong tệp JSON chỉ viết trên một dòng",
	"settings.export_groups": "Xuất các nhóm (Java)",
	"settings.export_groups.desc": "Lưu thông tin về nhóm trong tệp mô hình JSON (java)",
	"settings.credit": "Chú thích ghi công",
	"settings.credit.desc": "Thêm một câu bình luận nêu danh đề vào các tệp được xuất",
	"settings.default_path": "Đường dẫn texture Minecraft mặc định",
	"settings.default_path.desc": "Thư mục nơi BlockBench tải textures mặc định",
	"settings.image_editor": "Phần mềm chỉnh ảnh",
	"settings.image_editor.desc": "Phần mềm chỉnh ảnh mặc định để chỉnh sửa texture",
	"category.navigate": "Di chuyển",
	"category.tools": "Công cụ",
	"category.file": "Tệp",
	"category.blockbench": "Blockbench",
	"category.edit": "Chỉnh",
	"category.transform": "Biến đổi",
	"category.view": "Góc nhìn",
	"category.display": "Cài đặt hiển thị",
	"category.textures": "Kết cấu",
	"category.misc": "Tạp",
	"keybind.preview_select": "Chọn",
	"keybind.preview_rotate": "Xoay hướng nhìn",
	"keybind.preview_drag": "Kéo hướng nhìn",
	"keybind.confirm": "Xác nhận",
	"keybind.cancel": "Huỷ",
	"action.slider_inflate": "Làm phồng to",
	"action.slider_inflate.desc": "Phồng to các khối về mọi hướng mà không thay đổi UV",
	"action.slider_brush_size": "Kích cỡ",
	"action.slider_brush_size.desc": "Bán kính của cọ vẽ theo điểm ảnh",
	"action.slider_brush_opacity": "Độ trong suốt",
	"action.slider_brush_opacity.desc": "Độ trong suốt của cọ vẽ theo phần trăm",
	"action.slider_brush_softness": "Độ mềm mại",
	"action.slider_brush_softness.desc": "Độ mềm của cọ vẽ theo phần trăm",
	"action.uv_slider_pos_x": "Di chuyển theo chiều ngang",
	"action.uv_slider_pos_x.desc": "Di chuyển UV của các khối đã chọn theo chiều ngang",
	"action.uv_slider_pos_y": "Di chuyển theo chiều ngang",
	"action.uv_slider_pos_y.desc": "Di chuyển UV của các khối đã chọn theo chiều ngang",
	"action.uv_slider_size_x": "Thay đổi tỉ lệ theo chiều dọc",
	"action.uv_slider_size_x.desc": "Thay đổi tỉ lệ UV của các khối được chọn theo chiều ngang",
	"action.uv_slider_size_y": "Thay đổi tỉ lệ theo chiều ngang",
	"action.uv_slider_size_y.desc": "Thay đổi tỉ lệ UV của các khối được chọn theo chiều ngang",
	"action.vertex_snap_mode": "Chế độ nối",
	"action.vertex_snap_mode.desc": "Lựa chọn nếu Nối đỉnh sẽ di chuyển các phần tử đến vị trí đã chọn hay đổi kích cỡ của chúng",
	"action.move_tool": "Di chuyển",
	"action.move_tool.desc": "Công cụ để chọn và di chuyển các phần tử",
	"action.resize_tool": "Chỉnh kích cỡ",
	"action.resize_tool.desc": "Công cụ để chọn và chỉnh kích cỡ của các phần tử",
	"action.brush_tool": "Cọ vẽ",
	"action.brush_tool.desc": "Công cụ để vẽ lên các kết cấu trên bề mặt hoặc trong mục chỉnh sửa UV",
	"action.vertex_snap_tool": "Nối đỉnh",
	"action.vertex_snap_tool.desc": "Di chuyển khối này đến khối khác bằng cách nối hai đỉnh lại với nhau",
	"action.swap_tools": "Đổi công cụ",
	"action.swap_tools.desc": "Hoán đổi giữa công cụ di chuyển và chỉnh kích cỡ",
	"action.project_window": "Dự án...",
	"action.project_window.desc": "Mở hộp thoại dự án, nơi mà bạn có thể chỉnh sửa metadata (siêu dữ liệu) của mô hình",
	"action.open_model": "Mở mô hình",
	"action.open_model.desc": "Mở một tệp mô hình từ máy tính của bạn",
	"action.extrude_texture": "Texture đè",
	"action.extrude_texture.desc": "Tạo model dựa trên kết cấu bị kéo dãn",
	"action.export_blockmodel": "Xuất mô hình",
	"action.export_blockmodel.desc": "Xuất ra một mô hình khối hoặc item",
	"action.export_optifine_part": "Xuất một phần của OptiFine",
	"action.export_optifine_part.desc": "Xuất một phần mô hình thực thể của OptiFine",
	"action.export_optifine_full": "Xuất JEM của OptiFine",
	"action.export_optifine_full.desc": "Xuất toàn bộ mô hình thực thể OptiFine",
	"action.export_obj": "Xuất ra mô hình OBJ",
	"action.export_obj.desc": "Xuất Wavefont OBJ để kết xuất",
	"action.settings_window": "Cài đặt...",
	"action.settings_window.desc": "Mở hộp thoại cài đặt của Blockbench.",
	"action.plugins_window": "Plugin...",
	"action.plugins_window.desc": "Mở cửa sổ plugin store",
	"action.reset_layout": "Đặt lại layout",
	"action.reset_layout.desc": "Đặt lại Layout về mặc định của Blockbench",
	"action.load_plugin": "Tải Plugin từ tệp",
	"action.load_plugin.desc": "Tải một plugin bằng cách nhập tệp nguồn",
	"action.reload_plugins": "Tải lại Plugin",
	"action.reload_plugins.desc": "Tải lại tất cả plugin phát triển",
	"action.undo": "Hoàn tác",
	"action.undo.desc": "Hoàn tác thay đổi cuối cùng",
	"action.redo": "Làm lại",
	"action.redo.desc": "Hoàn tác lại thao tác hoàn tác cuối cùng",
	"action.copy": "Sao chép",
	"action.copy.desc": "Sao chép vùng chọn, mặt hoặc cài đặt hiển thị đã chọn",
	"action.paste": "Dán",
	"action.paste.desc": "Dán vùng chọn, mặt hoặc cài đặt hiển thị đã chọn",
	"action.cut": "Cắt",
	"action.cut.desc": "Cắt vùng chọn, mặt hoặc cài đặt hiển thị đã chọn",
	"action.add_cube": "Thêm khối",
	"action.add_cube.desc": "Thêm một khối mới",
	"action.add_group": "Thêm nhóm",
	"action.add_group.desc": "Thêm một nhóm hoặc khung xương mới",
	"action.outliner_toggle": "Bật/tắt Thêm Tùy chọn",
	"action.outliner_toggle.desc": "Bật/tắt các công tắc để hiển thị thêm tùy chọn trong Outliner",
	"action.duplicate": "Nhân bản",
	"action.delete": "Xoá",
	"action.sort_outliner": "Sắp xếp danh sách",
	"action.sort_outliner.desc": "Sắp xếp danh sách phần tử theo thứ tự bảng chữ cái",
	"action.select_window": "Chọn...",
	"action.select_window.desc": "Tìm và chọn các phần tử dựa trên thuộc tính của chúng",
	"action.invert_selection": "Đảo chọn",
	"action.invert_selection.desc": "Đảo ngược vùng chọn hiện tại của các phần tử",
	"action.select_all": "Chọn tất cả",
	"action.collapse_groups": "Đóng nhóm",
	"action.collapse_groups.desc": "Đóng tất cả các nhóm lại trên danh sách",
	"action.scale": "Chỉnh tỉ lệ...",
	"action.scale.desc": "Thay đổi tỷ lệ các phần tử đã chọn",
	"action.toggle_visibility": "Bật/tắt hiển thị",
	"action.toggle_visibility.desc": "Bật/tắt hiển thị của các phần tử đã chọn",
	"action.toggle_export": "Chuyển đổi chế độ Xuất",
	"action.toggle_export.desc": "Bật/tắt cài đặt xuất của các phần tử đã chọn",
	"action.toggle_autouv": "Chuyển đổi chế độ Auto UV",
	"action.toggle_autouv.desc": "Bật/tắt cài đặt Auto UV của các phần tử đã chọn",
	"action.toggle_shade": "Bật tắt đổ bóng",
	"action.toggle_shade.desc": "Bật tắt sự đổ bóng của các khối được chọn",
	"action.rename": "Sửa tên",
	"action.rename.desc": "Thay đổi tên của các phần tử hoặc nhóm đã chọn",
	"action.add_display_preset": "Giá trị cài sẵn mới",
	"action.add_display_preset.desc": "Tạo một Giá trị cài sẵn mới với các cài đặt hiển thị",
	"action.fullscreen": "Toàn màn hình",
	"action.fullscreen.desc": "Chuyển đổi chế độ Toàn màn hình",
	"action.zoom_in": "Phóng to",
	"action.zoom_in.desc": "Phóng to để tăng tỷ lệ giao diện",
	"action.zoom_out": "Zoom nhỏ",
	"action.zoom_out.desc": "Zoom nhỏ theo tỉ lệ của giao diện",
	"action.zoom_reset": "Đặt lại Zoom",
	"action.zoom_reset.desc": "Đặt lại độ zoom về mặc định là 100%",
	"action.reset_interface": "Đặt lại giao diện",
	"action.reset_interface.desc": "Đặt lại kích cỡ và vị trí của những thành phần giao diện",
	"action.screenshot_model": "Chụp mô hình",
	"action.screenshot_model.desc": "Chụp một ảnh đã cắt của mô hình từ góc độ hiện tại",
	"action.screenshot_app": "Chụp màn hình ứng dụng",
	"action.screenshot_app.desc": "Chụp màn hình toàn bộ ứng dụng",
	"action.import_texture": "Nhập texture",
	"action.import_texture.desc": "Nhập một hoặc nhiều texture từ hệ thống tệp của bạn",
	"action.create_texture": "Tạo texture",
	"action.create_texture.desc": "Tạo một texture trống hoặc texture mẫu",
	"action.save_textures": "Lưu texture",
	"action.save_textures.desc": "Lưu tất cả các texture chưa lưu",
	"action.animated_textures": "Phát texture động",
	"action.animated_textures.desc": "Phát và tạm dừng xem trước của các texture động",
	"action.origin_to_geometry": "Căn giữa pivot",
	"action.origin_to_geometry.desc": "Đặt điểm Pivot vào tâm của vùng chọn",
	"action.bone_reset_toggle": "Đặt lại phần xương",
	"action.bone_reset_toggle.desc": "Ngăn xương hiển thị các khối từ mô hình cha",
	"action.reload": "Tải lại Blockbench",
	"action.reload.desc": "Tải lại Blockbench. Điều này sẽ hủy bỏ tất cả tiến trình chưa lưu",
	"menu.file": "Tệp",
	"menu.edit": "Chỉnh",
	"menu.transform": "Biến đổi",
	"menu.display": "Hiển thị",
	"menu.view": "Tầm nhìn",
	"menu.file.new": "Tệp mới",
	"menu.file.recent": "Gần đây",
	"menu.file.import": "Nhập tệp",
	"menu.file.export": "Xuất tệp",
	"menu.transform.rotate": "Quay",
	"menu.transform.flip": "Lật",
	"menu.transform.center": "Căn giữa",
	"menu.transform.properties": "Thuộc tính",
	"menu.display.preset": "Áp dụng giá trị cài sẵn",
	"menu.display.preset_all": "Áp dụng giá trị cài sẵn ở mọi nơi",
	"menu.display.remove_preset": "Xóa bỏ giá trị cài sẵn",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Hình nền",
	"menu.view.screenshot": "Chụp hình",
	"menu.cube.color": "Đánh dấu màu",
	"menu.cube.texture": "Kết cấu",
	"menu.cube.texture.transparent": "Trong suốt",
	"menu.cube.texture.blank": "Trống không",
	"menu.group.sort": "Phân loại",
	"menu.texture.face": "Áp dụng lên cạnh",
	"menu.texture.file": "Tệp",
	"menu.texture.refresh": "Làm mới",
	"menu.texture.change": "Đổi tệp",
	"menu.texture.folder": "Mở trong thư mục",
	"menu.texture.edit": "Chỉnh",
	"menu.texture.export": "Lưu dưới dạng",
	"menu.texture.save": "Lưu",
	"menu.texture.properties": "Thuộc tính...",
	"menu.preview.background": "Hình nền",
	"menu.preview.background.load": "Tải",
	"menu.preview.background.position": "Vị trí",
	"menu.preview.background.lock": "Khóa vào máy ảnh",
	"menu.preview.screenshot": "Chụp hình",
	"menu.preview.perspective": "Phối cảnh",
	"menu.preview.perspective.normal": "Bình thường",
	"menu.preview.quadview": "4 góc nhìn khác nhau",
	"menu.preview.stop_drag": "Dừng định vị nền",
	"menu.uv.mapping.rotation": "Xoay",
	"menu.uv.texture": "Kết cấu UV",
	"cube.color.light_blue": "Xanh Dương sáng",
	"cube.color.yellow": "Vàng",
	"cube.color.orange": "Cam",
	"cube.color.red": "Đỏ",
	"cube.color.purple": "Tím",
	"cube.color.blue": "Xanh Dương",
	"cube.color.green": "Xanh Lá Cây",
	"cube.color.lime": "Xanh Chanh Vàng",
	"switches.visibility": "Ẩn",
	"switches.export": "Xuất tệp",
	"switches.autouv": "UV tự động",
	"panel.uv": "UV",
	"panel.display": "Hiển thị",
	"panel.textures": "Kết cấu",
	"panel.outliner": "Bảng sắp xếp",
	"uv_editor.title": "Chỉnh sửa UV",
	"uv_editor.all_faces": "Mọi mặt",
	"uv_editor.no_faces": "không có mặt",
	"face.north": "Bắc",
	"face.south": "Nam",
	"face.west": "Tây",
	"face.east": "Đông",
	"face.up": "Trên",
	"face.down": "Dưới",
	"direction.north": "Bắc",
	"direction.south": "Nam",
	"direction.west": "Tây",
	"direction.east": "Đông",
	"direction.top": "Trên",
	"direction.bottom": "Dưới",
	"display.slot.third_right": "Ngôi thứ ba tay phải",
	"display.slot.third_left": "Ngôi thứ ba tay trái",
	"display.slot.first_right": "Ngôi thứ nhất tay phải",
	"display.slot.first_left": "Ngôi thứ nhất tay trái",
	"display.slot.head": "Đầu",
	"display.slot.ground": "Sàn",
	"display.slot.frame": "Khung",
	"display.slot.gui": "Giao diện",
	"display.rotation": "Xoay",
	"display.translation": "Vị trí",
	"display.scale": "Kích thước",
	"display.slot": "Chỗ",
	"display.reference": "Mẫu tương quan",
	"display.reference.player": "Người chơi",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Giá để giáp",
	"display.reference.baby_zombie": "Tiểu Zombie",
	"display.reference.armor_stand_small": "Giá để giáp (nhỏ)",
	"display.reference.monitor": "Bình thường",
	"display.reference.bow": "Cung",
	"display.reference.block": "Khối",
	"display.reference.frame": "Khung vật phẩm",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Túi đồ",
	"display.reference.hud": "Hệ thống hiển thị",
	"display.preset.blank_name": "Nhập tên vào ô trống",
	"display.preset.item": "Vật phẩm mặc định",
	"display.preset.block": "Khối mặc định",
	"display.preset.handheld": "Vũ khí mặc định",
	"display.preset.rod": "Cần mặc định",
	"dialog.continue": "Tiếp tục",
	"message.square_textures": "Kết cấu phải là hình vuông",
	"message.unsaved_texture.title": "Kết cấu chưa lưu",
	"message.unsaved_texture.message": "Tất cả những thay đổi chưa lưu của kết cấu này sẽ bị mất. Bạn có muốn tiến hành chứ?",
	"action.vertex_snap_mode.move": "Di chuyển",
	"action.vertex_snap_mode.scale": "Chỉnh cỡ",
	"action.open_model_folder": "Mở thư mục mô hình",
	"action.open_model_folder.desc": "Mở thư mục mà chứa mô hình",
	"action.change_textures_folder": "Đổi vị trí của kết cấu",
	"action.change_textures_folder.desc": "Đổi thư mục nơi lưu các kết cấu",
	"menu.texture.particle": "Dùng cho hạt hiệu ứng",
	"message.update_notification.title": "Không thể cài bản cập nhật này được",
	"message.update_notification.message": "Một phiên bản mới của Blockbench đã có sẵn. Hãy bật chế độ \"Tự động thông báo bản cập nhật mới\" để thông báo có một bản cập nhật mới nhé.",
	"message.untextured": "Bề mặt này không có kết cấu",
	"dialog.toolbar_edit.title": "Tùy chỉnh thanh công cụ",
	"keybindings.reset": "Cài lại",
	"keybindings.clear": "Trống",
	"action.cube_counter": "Thống kê mô hình",
	"action.uv_rotation": "Xoay UV",
	"action.uv_rotation.desc": "Xoay mặt UV",
	"action.uv_grid": "Lưới đồ thị UV",
	"action.uv_grid.desc": "Độ phân giải của lưới mà bộ chọn UV bám vào",
	"action.uv_grid.auto": "Tự động",
	"action.uv_maximize": "Tối đa hoá UV",
	"action.uv_maximize.desc": "Đặt UV cho mặt này thành kết cấu đầy đủ",
	"action.uv_auto": "UV tự động",
	"action.uv_auto.desc": "Đặt kích thước UV của mặt này thành kích thước thực của mặt",
	"action.uv_rel_auto": "UV tự động tương đối",
	"action.uv_rel_auto.desc": "Đặt UV của mặt này thành vị trí và kích thước của mặt thực tế",
	"action.uv_mirror_x": "Gương UV X",
	"action.uv_mirror_x.desc": "Phản chiếu UV của mặt này trên trục X",
	"action.uv_mirror_y": "Gương UV Y",
	"action.uv_mirror_y.desc": "Phản chiếu UV của mặt này trên trục Y",
	"action.uv_transparent": "Xóa mặt",
	"action.uv_transparent.desc": "Xóa mặt hiện tại",
	"action.uv_reset": "Đặt lại mặt",
	"action.uv_reset.desc": "Đặt lại mặt hiện tại",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Tắt hiển thị cho mặt này nếu mặt được chọn của mô hình bị che",
	"action.auto_cullface": "Kích hoạt Cullface",
	"action.auto_cullface.desc": "Đặt cullface cho mặt này thành chính nó",
	"action.face_tint": "Sắc thái",
	"action.face_tint.desc": "Bật tùy chọn sắc thái cho mặt hiện tại",
	"menu.toolbar.edit": "Tùy chỉnh",
	"menu.toolbar.reset": "Đặt lại",
	"uv_editor.rotated": "Đã xoay",
	"uv_editor.auto_cull": "Cullface tự động",
	"uv_editor.copied": "Mặt đã sao chép",
	"uv_editor.pasted": "Dán mặt",
	"uv_editor.copied_x": "Đã sao chép %0 mặt",
	"uv_editor.reset": "Đặt lại mặt",
	"uv_editor.maximized": "Tối đa",
	"uv_editor.autouv": "Kích thước tự động",
	"uv_editor.mirrored": "Đã nhân đôi",
	"uv_editor.to_all": "Áp dụng cho mọi mặt",
	"uv_editor.transparent": "Làm trong suốt",
	"uv_editor.cullface_on": "Bật Cullface",
	"uv_editor.cullface_off": "Tắt Cullface",
	"uv_editor.tint_on": "Bật sắc thái",
	"uv_editor.tint_off": "Tắt sắc thái",
	"action.uv_apply_all": "Áp dụng cho mọi mặt",
	"action.uv_apply_all.desc": "Áp dụng cài đặt của mặt hiện tại cho tất cả mặt",
	"message.image_editor_missing.title": "Trình chỉnh sửa ảnh mặc định",
	"message.image_editor_missing.message": "Chọn tệp của trình chỉnh sửa hình ảnh của bạn.",
	"message.image_editor_missing.detail": "Blockbench không thể tìm thấy trình chỉnh sửa hình ảnh trên máy tính của bạn. Chọn tệp của trình chỉnh sửa hình ảnh ưa thích của bạn.",
	"action.update_autouv": "Cập nhật UV tự động",
	"action.update_autouv.desc": "Cập nhật ánh xạ UV tự động của các hình khối đã chọn",
	"category.uv": "UV",
	"status_bar.saved": "Đã lưu mô hình",
	"status_bar.unsaved": "Có những thay đổi chưa được lưu",
	"action.move_up": "Đi lên",
	"action.move_up.desc": "Di chuyển các phần tử đã chọn lên trên so với góc camera hiện tại",
	"action.move_down": "Đi xuống",
	"action.move_down.desc": "Di chuyển các phần tử đã chọn xuống dưới so với góc camera hiện tại",
	"action.move_left": "Sang trái",
	"action.move_left.desc": "Di chuyển các phần tử đã chọn sang trái so với góc camera hiện tại",
	"action.move_right": "Sang phải",
	"action.move_right.desc": "Di chuyển các phần tử đã chọn sang phải so với góc camera hiện tại",
	"action.move_forth": "Tiến",
	"action.move_forth.desc": "Di chuyển các phần tử được chọn về phía trước so với góc camera hiện tại",
	"action.move_back": "Lùi",
	"action.move_back.desc": "Di chuyển các phần tử đã chọn trở lại so với góc camera hiện tại",
	"layout.color.wireframe": "Khung xương",
	"layout.color.wireframe.desc": "Xem các dòng khung xương",
	"action.add_animation": "Thêm hoạt ảnh",
	"action.add_animation.desc": "Tạo một hoạt ảnh trống",
	"action.load_animation_file": "Nhập hoạt ảnh",
	"action.load_animation_file.desc": "Nhập tệp hoạt ảnh",
	"action.play_animation": "Chạy hoạt ảnh",
	"action.play_animation.desc": "Xem trước hoạt ảnh đã chọn",
	"action.slider_keyframe_time": "Mã thời gian",
	"action.slider_keyframe_time.desc": "Thay đổi mã thời gian của các khung hình chính đã chọn",
	"timeline.rotation": "Xoay",
	"timeline.position": "Vị trí",
	"timeline.scale": "Kích cỡ",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Hoạt ảnh",
	"panel.keyframe": "Khung hình chính",
	"panel.keyframe.type": "Khung hình chính (%0)",
	"generic.delete": "Xoá",
	"generic.rename": "Đổi tên",
	"message.no_animation_selected": "Bạn phải chọn một hình ảnh động để làm điều này",
	"message.no_bone_selected": "Bạn phải chọn một xương để làm điều này",
	"message.duplicate_groups.title": "Tên xương trùng lặp",
	"message.duplicate_groups.message": "Tên của xương này tồn tại trên nhiều xương. Điều này có thể gây ra vấn đề.",
	"action.delete_keyframes": "Xóa khung hình chính",
	"action.delete_keyframes.desc": "Xóa tất cả các khung hình chính đã chọn",
	"menu.animation": "Hoạt ảnh",
	"menu.animation.loop": "Tạo vòng lặp",
	"menu.animation.override": "Ghi đè",
	"menu.animation.anim_time_update": "Cập nhật thời gian hoạt ảnh",
	"message.display_skin_model.title": "Mô hình skin",
	"message.display_skin_model.message": "Chọn loại mô hình skin của bạn",
	"message.display_skin_model.classic": "Cổ điển",
	"message.display_skin_model.slim": "Mảnh khảnh",
	"message.bone_material": "Thay đổi chất liệu xương",
	"action.slider_animation_length": "Độ dài hoạt ảnh",
	"action.slider_animation_length.desc": "Thay đổi độ dài của hoạt ảnh đã chọn",
	"panel.variable_placeholders": "Trình giữ chỗ biến",
	"panel.variable_placeholders.info": "Liệt kê các biến bạn muốn xem trước qua name=value",
	"status_bar.vertex_distance": "Khoảng cách: %0",
	"dialog.create_gif.title": "Ghi GIF",
	"dialog.create_gif.length": "Dài",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Bắt đầu hoạt ảnh",
	"category.animation": "Hoạt ảnh",
	"action.record_model_gif": "Ghi GIF...",
	"action.record_model_gif.desc": "Ghi lại một GIF động của mô hình từ góc độ hiện tại",
	"display.mirror": "Gương",
	"data.separator": "Phân cách",
	"menu.preview.background.set_position": "Đặt vị trí",
	"dialog.toolbar_edit.hidden": "Ẩn",
	"action.export_class_entity": "Xuất thực thể Java",
	"action.export_class_entity.desc": "Xuất mô hình thực thể dưới dạng Java",
	"settings.seethrough_outline": "Đường viền X-Ray",
	"settings.seethrough_outline.desc": "Hiển thị đường viền qua các đối tượng",
	"mode.edit": "Chỉnh sửa",
	"mode.paint": "Vẽ",
	"mode.display": "Hiển thị",
	"mode.animate": "Hoạt ảnh",
	"status_bar.recording_gif": "Ghi GIF",
	"status_bar.processing_gif": "Đang xử lý GIF",
	"settings.backup_retain": "Lượng lưu trữ dự phòng",
	"settings.backup_retain.desc": "Đặt thời gian Blockbench lưu trữ các bản sao lưu cũ theo ngày",
	"action.rotate_tool": "Xoay",
	"action.rotate_tool.desc": "Công cụ để chọn và xoay phần tử",
	"action.fill_tool": "Thùng sơn",
	"action.fill_tool.desc": "Thùng sơn dùng để lấp mặt bằng một màu",
	"action.eraser": "Tẩy",
	"action.eraser.desc": "Công cụ tẩy sẽ thay thế màu sắc trên kết cấu với độ trong suốt",
	"action.color_picker": "Công cụ nhỏ mắt",
	"action.color_picker.desc": "Công cụ để chọn màu điểm ảnh trên kết cấu của bạn",
	"switches.mirror": "Gương UV",
	"language_name": "Tiếng việt",
	"message.plugin_reload": "Đã tải lại %0 plugin cục bộ",
	"settings.brightness": "Độ sáng",
	"settings.brightness.desc": "Độ sáng bản xem trước. Mặc định là 50",
	"menu.preview.perspective.reset": "Đặt lại máy ảnh",
	"action.fill_mode": "Chế độ làm đầy",
	"action.fill_mode.face": "Mặt",
	"action.fill_mode.color": "Màu",
	"action.toggle_mirror_uv": "Gương UV",
	"action.toggle_mirror_uv.desc": "Chuyển đổi phản chiếu UV trên trục X của các khối đã chọn",
	"menu.texture.blank": "Áp dụng cho mặt không có kết cấu",
	"dialog.scale.select_overflow": "Chọn tràn",
	"action.action_control": "Kiểm soát hành động",
	"action.action_control.desc": "Tìm kiếm và thực hiện bất kỳ hành động có sẵn",
	"keybindings.recording": "Ghi thao tác gõ",
	"keybindings.press": "Nhấn một phím hoặc tổ hợp phím hoặc nhấp vào bất kỳ đâu trên màn hình để ghi lại thao tác gõ phím của bạn.",
	"action.pivot_tool": "Công cụ tâm quay",
	"action.pivot_tool.desc": "Công cụ thay đổi điểm tâm xoay của các phần tử và xương",
	"action.slider_animation_speed": "Tốc độ phát lại",
	"action.slider_animation_speed.desc": "Tốc độ phát lại của dòng thời gian tính bằng phần trăm",
	"action.previous_keyframe": "Khung hình chính trước đó",
	"action.previous_keyframe.desc": "Chuyển đến khung hình chính trước đó",
	"action.next_keyframe": "Khung hình chính tiếp theo",
	"action.next_keyframe.desc": "Chuyển đến khung hình chính tiếp theo",
	"message.outdated_client.title": "Ứng dụng lỗi thời",
	"message.outdated_client.message": "Vui lòng cập nhật phiên bản Blockbench mới nhất để thực hiện việc này.",
	"action.export_asset_archive": "Tải về lưu trữ",
	"action.export_asset_archive.desc": "Tải xuống một kho lưu trữ với mô hình và tất cả các kết cấu trong đó",
	"action.upload_sketchfab": "Tải lên Sketchfab",
	"message.sketchfab.name_or_token": "Vui lòng nhập mã thông báo Sketchfab của bạn và tên",
	"dialog.sketchfab_uploader.title": "Tải lên mô hình Sketchfab",
	"dialog.sketchfab_uploader.token": "Mã thông báo API",
	"dialog.sketchfab_uploader.about_token": "Mã thông báo được sử dụng để kết nối Blockbench với tài khoản Sketchfab của bạn. Bạn có thể tìm thấy nó trên %0",
	"dialog.sketchfab_uploader.name": "Tên mô hình",
	"dialog.sketchfab_uploader.description": "Miêu tả",
	"dialog.sketchfab_uploader.tags": "Thẻ",
	"settings.sketchfab_token": "Mã thông báo Sketchfab",
	"settings.sketchfab_token.desc": "Mã thông báo cho phép Blockbench tải lên tài khoản Sketchfab của bạn",
	"panel.color": "Màu",
	"data.origin": "Tâm quay",
	"message.sketchfab.success": "Đã tải mô hình lên thành công",
	"message.sketchfab.error": "Không thể tải mô hình lên Sketchfab",
	"settings.outliner_colors": "Màu viền ngoài",
	"settings.outliner_colors.desc": "Hiển thị phần tử và màu nhóm trong phần ngoài",
	"action.upload_sketchfab.desc": "Tải mô hình của bạn lên Sketchfab",
	"action.element_colors": "Màu khối",
	"action.element_colors.desc": "Hiển thị màu sắc của khối lập phương ở lớp ngoài",
	"texture.error.file": "Không tìm thấy tệp",
	"texture.error.parent": "Tệp kết cấu do chế độ gốc cung cấp",
	"message.recover_backup.title": "Khôi phục mô hình",
	"message.recover_backup.message": "Blockbench đã bị đóng mà không lưu. Bạn có muốn khôi phục mô hình?",
	"message.invalid_session.title": "Mã phiên không hợp lệ",
	"message.invalid_session.message": "Phiên mà bạn đang cố gắng tham gia đã hết hạn hoặc mã thông báo được cung cấp không hợp lệ.",
	"dialog.create_texture.power": "Kích thước luỹ thừa 2",
	"dialog.create_gif.turn": "Tốc độ xoay",
	"action.edit_session": "Chỉnh sửa phiên...",
	"action.edit_session.desc": "Kết nối với phiên chỉnh sửa để cộng tác với những người dùng khác",
	"action.reset_keyframe": "Đặt lại khung hình chính",
	"action.reset_keyframe.desc": "Đặt lại tất cả các giá trị của các khung hình chính đã chọn",
	"dialog.edit_session.title": "Chỉnh sửa phiên",
	"edit_session.username": "Tên người dùng",
	"edit_session.token": "Mã thông báo",
	"edit_session.about": "Phiên chỉnh sửa có thể được sử dụng để cộng tác trên các mô hình trên internet. Tạo một phiên, sao chép mã thông báo và gửi cho bạn bè, những người sau đó có thể sử dụng nó để tham gia.",
	"edit_session.join": "Tham gia phiên",
	"edit_session.create": "Tạo phiên",
	"edit_session.quit": "Thoát phiên",
	"edit_session.joined": "%0 đã tham gia phiên",
	"edit_session.left": "%0 rời khỏi phiên",
	"edit_session.quit_session": "Đã rời khỏi phiên hiện tại",
	"edit_session.status": "Trạng thái",
	"edit_session.hosting": "Hosting",
	"edit_session.connected": "Đã kết nối với một phiên",
	"dialog.sketchfab_uploader.private": "Riêng tư (Pro)",
	"dialog.sketchfab_uploader.password": "Mật khẩu (Pro)",
	"action.uv_select_all": "Chọn tất cả",
	"action.uv_select_all.desc": "Chọn tất cả các mặt trong hộp thoại UV",
	"panel.chat": "Trò chuyện",
	"edit_session.welcome": "Chào mừng đến với phiên này bởi %0",
	"dialog.yes": "Vâng",
	"dialog.no": "Không",
	"generic.remove": "Loại bỏ",
	"generic.download": "Tải về",
	"generic.search": "Tìm",
	"dates.today": "Hôm nay",
	"dates.yesterday": "Hôm qua",
	"dates.this_week": "Tuần này",
	"dates.weeks_ago": "%0 tuần trước",
	"mode.start.new": "Mới",
	"mode.start.recent": "Gần đây",
	"format.free": "Mô hình chung",
	"format.free.desc": "Mô hình không hạn chế. Đối với công cụ trò chơi, kết xuất, v.v.",
	"format.java_block": "Java Khối/Vật phẩm",
	"format.java_block.desc": "Mô hình khối hoặc vật phẩm cho Minecraft phiên bản Java .",
	"format.bedrock": "Thực thể Bedrock",
	"format.bedrock.desc": "Mô hình Minecraft phiên bản Bedrock cho các thực thể và vật phẩm đính kèm",
	"format.bedrock_old": "Mô hình di sản Bedrock",
	"format.bedrock_old.desc": "Mô hình thực thể minecraft phiên bản Bedrock trước 1.12",
	"format.modded_entity": "Thực thể sửa đổi",
	"format.modded_entity.desc": "Mô hình thực thể cho minecraft mod. Có thể xuất dưới dạng tệp java.",
	"format.optifine_entity": "Thực thể OptiFine",
	"format.optifine_entity.desc": "Mô hình thực thể tùy chỉnh cho mod OptiFine",
	"keys.mouse": "Nút chuột %0",
	"message.cleared_blank_faces.title": "Mặt trống",
	"message.cleared_blank_faces.message": "Blockbench đã tìm thấy %0 khối không có kết cấu. Bạn có muốn loại bỏ các phần tử đó?",
	"message.wireframe.enabled": "Đã bật chế độ xem khung dây",
	"message.wireframe.disabled": "Đã tắt chế độ xem khung dây",
	"dialog.convert_project.title": "Chuyển đổi dự án",
	"dialog.create_texture.double_use": "Giữ nhiều kết cấu chiếm dụng",
	"dialog.model_stats.title": "Thống kê mô hình",
	"dialog.model_stats.cubes": "Khối",
	"dialog.model_stats.locators": "Bộ định vị",
	"dialog.model_stats.groups": "Các nhóm",
	"dialog.model_stats.vertices": "Các đỉnh",
	"dialog.model_stats.faces": "Các mặt",
	"settings.username": "Tên người dùng",
	"settings.username.desc": "Tên người dùng cho các phiên chỉnh sửa",
	"settings.painting_grid": "Tranh lưới đồ thị",
	"settings.painting_grid.desc": "Hiển thị lưới trên các thành phần kết cấu ở chế độ vẽ",
	"action.convert_project": "Chuyển đổi dự án",
	"action.convert_project.desc": "Chuyển đổi dự án hiện tại sang dự án cho định dạng mô hình khác",
	"action.close_project": "Đóng dự án",
	"action.close_project.desc": "Đóng dự án đang mở",
	"action.export_bedrock": "Xuất hình học Bedrock",
	"action.export_bedrock.desc": "Xuất mô hình dưới dạng tệp hình học phiên bản bedrock.",
	"action.save_project": "Lưu dự án",
	"action.save_project.desc": "Lưu mô hình hiện tại dưới dạng tệp dự án",
	"action.save_project_as": "Lưu dự án dưới dạng",
	"action.save_project_as.desc": "Lưu mô hình hiện tại dưới dạng tệp dự án tại một vị trí mới",
	"action.export_over": "Lưu mô hình",
	"action.export_over.desc": "Lưu mô hình, kết cấu và hoạt ảnh bằng cách ghi đè lên các tệp",
	"action.add_locator": "Thêm định vị",
	"action.add_locator.desc": "Thêm một bộ định vị mới để kiểm soát vị trí của các hạt, dây xích, v.v.",
	"action.uv_turn_mapping": "Xoay bản đồ",
	"action.uv_turn_mapping.desc": "Xoay bản đồ UV khoảng 90 độ",
	"action.remove_blank_faces": "Xóa mặt trống",
	"action.remove_blank_faces.desc": "Xóa tất cả các mặt không có kết cấu của vùng chọn",
	"web.download_app": "Tải ứng dụng",
	"uv_editor.turned": "Đã xoay bản đồ",
	"display.reference.crossbow": "Nỏ",
	"dialog.settings.search_results": "kết quả tìm kiếm",
	"settings.animation_snap": "Chụp hoạt ảnh",
	"settings.animation_snap.desc": "Khoảng thời gian chụp mặc định cho các khung hình chính trong thời gian hoạt ảnh tính theo mỗi giây. Điều này cũng có thể được thay đổi trên mỗi hoạt ảnh. Giá trị mặc định là 24.",
	"action.import_optifine_part": "Nhập phần OptiFine",
	"action.import_optifine_part.desc": "Nhập một mô hình phần thực thể cho OptiFine",
	"data.locator": "Định vị",
	"mode.start.no_recents": "Không có mô hình mở gần đây",
	"panel.element": "Thuộc tính",
	"panel.element.position": "Vị trí",
	"panel.element.size": "Kích thước",
	"panel.element.origin": "Điểm tâm quay",
	"panel.element.rotation": "Xoay",
	"message.canvas_limit_error.title": "Lỗi giới hạn canvas",
	"message.canvas_limit_error.message": "Không thể thực hiện hành động chính xác vì định dạng giới hạn canvas ở 48 đơn vị. Thay đổi điểm trung tâm quay để ngăn chặn điều này.",
	"data.effect": "Hiệu ứng",
	"generic.name": "Tên",
	"settings.recent_projects": "Mẫu gần đây",
	"settings.recent_projects.desc": "Số lượng tối đa các mô hình gần đây có thể nhớ",
	"settings.volume": "Âm lượng",
	"settings.volume.desc": "Điều khiển âm lượng cho hiệu ứng âm thanh trong hoạt ảnh",
	"action.clear_timeline": "Xóa dòng thời gian",
	"action.clear_timeline.desc": "Xóa tất cả xương không được chọn khỏi dòng thời gian",
	"action.select_effect_animator": "Hiệu ứng hoạt ảnh",
	"action.select_effect_animator.desc": "Mở dòng thời gian để thêm hiệu ứng âm thanh và hạt",
	"action.timeline_focus": "Lọc kênh",
	"action.timeline_focus.desc": "Chọn kênh hoạt ảnh để hiển thị trong dòng thời gian",
	"timeline.particle": "Hạt",
	"timeline.sound": "Âm thanh",
	"timeline.effects": "Hiệu ứng",
	"data.format": "Định dạng",
	"format.optifine_part": "Phần OptiFine",
	"format.optifine_part.desc": "Phần JPM cho các mô hình thực thể OptiFine",
	"action.reverse_keyframes": "khung hình chính đảo ngược",
	"action.reverse_keyframes.desc": "Đảo ngược thứ tự của các khung hình chính đã chọn",
	"generic.help": "Trợ giúp",
	"message.removed_faces": "Đã loại bỏ mặt %0",
	"dialog.sketchfab_uploader.draft": "Bản thảo",
	"action.slider_pos": "Di chuyển %0",
	"action.slider_pos.desc": "Di chuyển các phần tử trên trục %0",
	"action.slider_size": "Kích thước %0",
	"action.slider_size.desc": "Thay đổi kích thước các phần tử trên trục %0",
	"action.slider_rotation": "Xoay %0",
	"action.slider_rotation.desc": "Xoay các phần tử trên trục %0",
	"action.slider_origin": "Tâm quay %0",
	"action.slider_origin.desc": "Di chuyển tâm quay %0",
	"action.rotate_cw": "Xoay %0 +90",
	"action.rotate_cw.desc": "Xoay các phần tử đã chọn 90° trên trục %0",
	"action.rotate_ccw": "Xoay %0 -90",
	"action.rotate_ccw.desc": "Xoay các phần tử đã chọn -90° trên trục %0",
	"action.flip": "Lật %0",
	"action.flip.desc": "Lật các phần tử đã chọn trên trục %0",
	"action.center": "Trung tâm %0",
	"action.center.desc": "Đặt trung tâm các phần tử đã chọn trên trục %0",
	"action.bring_up_all_animations": "Mang lên tất cả các hoạt ảnh",
	"panel.bone": "Xương",
	"data.color": "Màu",
	"generic.export": "Xuất",
	"generic.none": "không có",
	"status_bar.recording": "Quay Timelapse",
	"message.add_to_palette": "Đã thêm vào bảng màu",
	"message.size_modifiers": "Giữ phím Ctrl hoặc Shift để chuyển đổi theo các bước nhỏ hơn.",
	"message.timelapse_start": "Bắt đầu Timelapse",
	"message.timelapse_stop": "Tạm dừng Timelapse",
	"message.import_palette.replace_palette": "Thay thế bảng màu cũ",
	"message.import_palette.threshold": "Ngưỡng hợp nhất",
	"dialog.timelapse.interval": "Khoảng thời gian (Giây)",
	"dialog.timelapse.source": "Nguồn",
	"dialog.timelapse.source.interface": "Giao diện",
	"dialog.timelapse.source.locked": "Góc khóa",
	"dialog.timelapse.destination": "Thư mục đích",
	"layout.color.checkerboard": "Nền caro",
	"layout.color.checkerboard.desc": "Nền của canvas và trình chỉnh sửa UV",
	"layout.font.code": "Mã phông chữ",
	"layout.css": "CSS tùy chỉnh",
	"settings.category.paint": "Vẽ",
	"settings.deactivate_size_limit": "Vô hiệu hóa giới hạn kích thước",
	"settings.deactivate_size_limit.desc": "Vô hiệu hóa giới hạn kích thước cho các định dạng mô hình cụ thể. CẢNH BÁO: Điều này có thể khiến mô hình không hợp lệ.",
	"settings.brush_opacity_modifier": "Điều chỉnh độ mờ của cọ vẽ",
	"settings.brush_opacity_modifier.desc": "Sửa đổi độ mờ của cọ vẽ khi sử dụng bút cảm ứng",
	"settings.brush_size_modifier": "Sửa đổi kích thước cọ vẽ",
	"settings.brush_size_modifier.desc": "Sửa đổi kích thước cọ vẽ khi sử dụng bút cảm ứng",
	"settings.brush_modifier.pressure": "Lực nhấn",
	"settings.brush_modifier.tilt": "Nghiêng",
	"category.color": "Màu",
	"action.import_theme": "Nhập chủ đề",
	"action.export_theme": "Xuất chủ đề",
	"action.export_theme.desc": "Tạo tệp chủ đề dựa trên cài đặt hiện tại",
	"action.slider_color_h": "Tông màu",
	"action.slider_color_s": "Độ bão hoà",
	"action.slider_color_v": "Sắc độ",
	"action.add_to_palette": "Thêm vào bảng màu",
	"action.add_to_palette.desc": "Thêm màu đã chọn vào bảng màu",
	"action.import_palette": "Nhập bảng màu",
	"action.import_palette.desc": "Nhập tệp bảng màu",
	"action.export_palette": "Xuất bảng màu",
	"action.export_palette.desc": "Xuất bảng dưới dạng tệp .GPL",
	"action.generate_palette": "Tạo bảng màu...",
	"action.generate_palette.desc": "Tạo bảng màu từ kết cấu",
	"action.sort_palette": "Sắp xếp bảng",
	"action.sort_palette.desc": "Sắp xếp màu trên bảng màu theo màu sắc và độ sáng",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Ghi timelapse quá trình lập mô hình của bạn",
	"action.add_keyframe": "Thêm khung hình chính",
	"action.add_keyframe.desc": "Tự động thêm khung hình chính. Nhấn shift để các giá trị thành mặc định",
	"action.bring_up_all_animations.desc": "Đưa tất cả các hoạt ảnh đã sửa đổi vào dòng thời gian",
	"timeline.timeline": "Hướng dẫn",
	"menu.palette.load.default": "Mặc định",
	"generic.import": "Nhập",
	"settings.brush_modifier.none": "không có",
	"action.export_entity": "Xuất thực thể Bedrock",
	"action.export_entity.desc": "Thêm mô hình thực thể hiện tại vào tệp mobs.json",
	"settings.highlight_cubes": "Làm nổi bật yếu tố",
	"settings.highlight_cubes.desc": "Làm nổi bật các phần tử khi bạn di chuột qua hoặc chọn chúng",
	"action.add_marker": "Đặt dấu",
	"action.add_marker.desc": "Đặt điểm đánh dấu dòng thời gian",
	"timeline.pre_effect_script": "Kịch bản",
	"format.skin": "Minecraft Skin",
	"format.skin.desc": "Chỉnh sửa giao diện người chơi và thực thể",
	"message.sketchfab.setup_guide": "Bạn muốn học cách thiết lập các mô hình trong Sketchfab? Đọc %0",
	"dialog.skin.title": "Tạo skin Minecraft",
	"dialog.skin.model": "Mô hình",
	"action.toggle_skin_layer": "Chuyển lớp skin",
	"action.toggle_skin_layer.desc": "Chuyển đổi lớp mũ và quần áo của mô hình skin",
	"action.gui_light": "GUI sáng",
	"action.gui_light.desc": "Chọn nguồn sáng cho vật phẩm trong kho",
	"action.gui_light.side": "Sáng bên",
	"action.gui_light.front": "Sáng trước",
	"action.move_keyframe_back": "Di chuyển khung hình chính trở lại",
	"action.move_keyframe_forth": "Di chuyển khung hình chính tiến tới",
	"menu.help": "Trợ giúp",
	"menu.help.discord": "Discord",
	"menu.help.report_issue": "Báo cáo một vấn đề",
	"menu.help.plugin_documentation": "Tài liệu API plugin",
	"menu.help.search_action": "Tìm kiếm và chạy hành động",
	"menu.help.donate": "Donate",
	"menu.help.about": "Giới thiệu...",
	"menu.preview.background.clipboard": "Tải từ bảng tạm",
	"dialog.ignore": "Phớt lờ",
	"generic.unset": "Bỏ đặt",
	"message.invalid_builtin_parent.title": "Mô hình gốc không hợp lệ",
	"message.invalid_builtin_parent.message": "Liên kết đến mô hình gốc '%0' không hợp lệ đã bị xóa để xuất một mô hình hợp lệ.",
	"dialog.resize_texture.fill": "Làm đầy với",
	"dialog.resize_texture.fill.transparent": "Trong suốt",
	"dialog.resize_texture.fill.color": "Màu",
	"dialog.resize_texture.fill.repeat": "Lặp lại",
	"dialog.scale.element_pivot": "Yếu tố tâm quay",
	"dialog.scale.selection_center": "Chọn trung tâm",
	"dialog.create_gif.length_mode": "Thiết lập độ dài",
	"dialog.create_gif.length_mode.seconds": "Giây",
	"dialog.create_gif.length_mode.frames": "khung hình chính",
	"dialog.create_gif.length_mode.animation": "Hoạt ảnh dài",
	"dialog.create_gif.length_mode.turntable": "Xoay vòng",
	"dialog.save_angle.projection": "Dự án",
	"dialog.save_angle.projection.perspective": "Phối cảnh",
	"dialog.save_angle.projection.orthographic": "Trực giao",
	"dialog.sketchfab_uploader.animations": "Hoạt ảnh",
	"dialog.settings.theme": "Chủ đề",
	"settings.category.interface": "Giao diện",
	"settings.preview_checkerboard": "Xem trước nền caro",
	"settings.preview_checkerboard.desc": "Chuyển đổi nền caro đằng sau bản xem trước",
	"settings.uv_checkerboard": "Chỉnh UV nền caro",
	"settings.uv_checkerboard.desc": "Chuyển đổi nền caro phía sau trình chỉnh sửa UV",
	"category.paint": "Vẽ",
	"action.fill_mode.color_connected": "Kết nối màu sắc",
	"action.draw_shape_type": "Loại hình dạng",
	"action.draw_shape_type.rectangle": "Hình vuông",
	"action.draw_shape_type.rectangle_h": "Hình vuôngt(Rỗng)",
	"action.draw_shape_type.ellipse": "Hình elip",
	"action.draw_shape_type.ellipse_h": "Hình elip(Rỗng)",
	"action.draw_shape_type.line": "Đường kẻ",
	"action.mirror_painting": "Tranh gương",
	"action.mirror_painting.description": "Phản chiếu các nét vẽ của bạn sang phía bên kia của mô hình",
	"action.lock_alpha": "Khóa kênh Alpha",
	"action.lock_alpha.description": "Khóa độ trong suốt của tất cả các điểm ảnh",
	"action.draw_shape_tool": "Vẽ hình",
	"action.draw_shape_tool.desc": "Công cụ để vẽ các hình đơn giản trên kết cấu",
	"action.export_gltf": "Xuất mô hình glTF",
	"action.export_gltf.desc": "Xuất mô hình và hoạt ảnh dưới dạng tệp glTF để chia sẻ và hiển thị",
	"action.transform_space": "Thay đổi không gian",
	"action.transform_space.desc": "Không gian biến đổi mặc định cho khối và xương",
	"action.transform_space.global": "Tổng thể",
	"action.transform_space.local": "Cục bộ",
	"action.toggle_camera_projection": "Chuyển đổi phép chiếu camera",
	"action.toggle_camera_projection.desc": "Chuyển đổi phép chiếu camera giữa phối cảnh và trực giao",
	"action.load_camera_angle": "Góc camera: %0",
	"action.load_camera_angle.desc": "Tải góc camera '%0'",
	"action.slider_face_tint": "Chỉ số màu sáng",
	"action.slider_face_tint.desc": "Đặt mục chỉ số của mặt hiện tại. -1 có nghĩa là không đặt.",
	"menu.help.quickstart": "Hướng dẫn nhanh",
	"menu.help.developer": "Nhà phát triển",
	"menu.help.developer.dev_tools": "Mở công cụ dành cho nhà phát triển",
	"menu.help.developer.reset_storage": "Khôi phục cài đặt gốc",
	"menu.help.developer.reset_storage.confirm": "Bạn có chắc chắn muốn đặt lại Blockbench về cài đặt gốc không? Thao tác này sẽ xóa tất cả cài đặt tùy chỉnh, tổ hợp phím và plugin đã cài đặt.",
	"menu.help.developer.cache_reload": "Tải lại bộ nhớ đệm",
	"menu.preview.orthographic": "Trực Giao",
	"menu.preview.save_angle": "Lưu nhìn...",
	"menu.preview.angle": "Góc nhìn",
	"menu.preview.angle.initial": "Góc ban đầu",
	"menu.preview.maximize": "Tối đa hóa",
	"uv_editor.copy_selection": "Sao chép lựa chọn",
	"uv_editor.paste_selection": "Dán lựa chọn",
	"uv_editor.copy_paste_tool.place": "Kiểm tra",
	"uv_editor.copy_paste_tool.mirror_x": "Gương X",
	"uv_editor.copy_paste_tool.mirror_y": "Gương Y",
	"uv_editor.copy_paste_tool.rotate": "Xoay 90 độ",
	"dialog.project.modded_entity_version": "Xuất phiên bản",
	"dialog.save_angle.position": "Vị trí máy ảnh",
	"dialog.save_angle.target": "Tiêu điểm",
	"dialog.skin.pose": "Tư thế",
	"layout.color.frame": "Khung cửa sổ",
	"layout.color.frame.desc": "Đường viền và thanh tiêu đề của cửa sổ",
	"settings.large_grid_size": "Kích thước khối lưới đồ thị",
	"settings.large_grid_size.desc": "Kích thước của khối lưới",
	"action.load_plugin_from_url": "Tải Plugin từ URL",
	"action.load_plugin_from_url.desc": "Tải plugin từ máy chủ bằng cách chỉ định URL",
	"action.cube_counter.desc": "Hiển thị số lượng phần tử hiện tại và các thống kê khác",
	"action.unlock_everything": "Mở khóa tất cả",
	"action.unlock_everything.desc": "Mở khóa tất cả các nhóm và phần tử phần ngoài.",
	"action.load_palette": "Tải bảng màu",
	"action.load_palette.desc": "Tải một trong các giá trị cài sẵn bảng màu được tích hợp hoặc đã lưu",
	"action.toggle_locked": "Chuyển đổi khóa",
	"action.toggle_locked.desc": "Chuyển đổi xem các phần tử đã chọn có bị khóa hay không",
	"action.apply_display_preset": "Áp dụng giá trị cài sẵn",
	"action.apply_display_preset.desc": "Áp dụng cài đặt hiển thị mặc định hoặc giá trị cài sẵn",
	"action.apply_display_preset.here": "Áp dụng cho vị trí này",
	"action.apply_display_preset.everywhere": "Áp dụng cho tất cả các vị trí",
	"action.resolve_keyframe_expressions": "Giải quyết khung hình chính",
	"action.resolve_keyframe_expressions.desc": "Giải quyết các biểu thức toán học của khung hình chính được chọn",
	"action.fold_all_animations": "Thu gọn tất cả hoạt ảnh",
	"menu.palette.load.empty": "Trống",
	"switches.lock": "Khóa",
	"settings.render_sides": "Kết xuất bên",
	"settings.render_sides.desc": "Chọn những mặt được hiển thị",
	"settings.render_sides.auto": "Tự động",
	"settings.render_sides.front": "Ngoài",
	"settings.render_sides.double": "Trong và ngoài",
	"generic.enable": "Cho phép",
	"generic.disable": "Tắt",
	"generic.redacted": "Điều chỉnh lại",
	"dialog.select_texture.import_all": "Nhập tất cả",
	"dialog.skin.layer_template": "Lớp kết cấu",
	"about.version.up_to_date": "Cập nhật",
	"about.version.update_available": "Phiên bản %0 có sẵn",
	"settings.category.application": "Ứng dụng",
	"settings.streamer_mode": "Chế độ phát trực tuyến",
	"settings.streamer_mode.desc": "Ẩn thông tin nhạy cảm như các mô hình gần đây",
	"settings.automatic_updates": "Tự động cập nhật",
	"settings.automatic_updates.desc": "Tự động tải xuống phiên bản mới và cập nhật Blockbench",
	"action.rotation_space": "Không gian xoay",
	"action.focus_on_selection": "Xem trung tâm vùng chọn",
	"action.focus_on_selection.desc": "Căn chỉnh camera đối diện với tâm của vùng chọn hiện tại",
	"action.jump_to_timeline_start": "Đến điểm đầu hoạt ảnh",
	"action.jump_to_timeline_end": "Đến điểm cuối hoạt ảnh",
	"menu.help.updating": "Đang cập nhật (%0%)",
	"menu.help.update_failed": "Cập nhật thất bại",
	"menu.animation.loop.once": "Chạy một lần",
	"menu.animation.loop.hold": "Giữ khung hình cuối",
	"menu.animation.loop.loop": "Lặp",
	"interface.streamer_mode_on": "Đã bật chế độ truyền phát",
	"generic.reset": "Đặt lại",
	"generic.restore": "Khôi Phục",
	"keys.mousewheel": "Con lăn chuột",
	"message.delete_animation.title": "Xoá hoạt ảnh",
	"message.delete_animation.message": "Hoạt ảnh đã bị xóa khỏi Blockbench. Bạn cũng muốn xóa hoạt ảnh khỏi tệp đã lưu không?",
	"message.no_animation_to_import": "Không có hoạt ảnh để nhập",
	"dialog.material_instances.title": "Chỉnh sửa trường hợp vật liệu",
	"dialog.animation_import.title": "Chọn hoạt ảnh để nhập",
	"dialog.create_texture.padding": "Đệm",
	"settings.fov": "FOV",
	"settings.fov.desc": "Trường nhìn của máy ảnh. Mặc định là 45",
	"settings.minify_bbmodel": "Tệp dự án được rút gọn",
	"settings.minify_bbmodel.desc": "Viết tệp .bbmodel được rút gọn thành một dòng",
	"action.edit_material_instances": "Chỉnh sửa trường hợp vật liệu",
	"action.edit_material_instances.desc": "Chỉnh sửa tên đối tượng vật liệu cho hình dạng khối nền",
	"action.save_all_animations": "Lưu tất cả hoạt ảnh",
	"action.save_all_animations.desc": "Lưu tất cả các hoạt ảnh động hiện đang tải",
	"action.keyframe_interpolation": "Nội suy",
	"action.keyframe_interpolation.desc": "Chọn chế độ nội suy khung hình chính",
	"action.keyframe_interpolation.linear": "Tuyến tính",
	"action.keyframe_interpolation.catmullrom": "Trơn tru",
	"action.timeline_focus.hide_empty": "Ẩn các kênh trống",
	"menu.file.preferences": "Thiết lập người dùng",
	"menu.animation.blend_weight": "Trọng lượng hỗn hợp",
	"menu.animation.save": "Lưu",
	"menu.animation.properties": "Thuộc tính...",
	"menu.animation.file": "Tệp",
	"menu.animation.snapping": "Chụp nhanh",
	"menu.animation.open_location": "Hiển thị trong File Explorer",
	"panel.keyframe.add_data_point": "Thêm điểm dữ liệu khung hình chính",
	"panel.keyframe.remove_data_point": "Xóa điểm dữ liệu",
	"panel.keyframe.pre": "Đến",
	"panel.keyframe.post": "Sau đó",
	"generic.all": "Tất cả",
	"message.small_face_dimensions.title": "Kích thước mặt không tương thích",
	"message.small_face_dimensions.message": "Vùng chọn chứa các mặt có kích thước nhỏ hơn 1 đơn vị theo một hướng. Hệ thống lập bản đồ Hộp UV coi bất kỳ mặt nào dưới ngưỡng đó là rộng 0 điểm ảnh. Do đó, kết cấu trên những mặt đó có thể không hoạt động chính xác.",
	"message.small_face_dimensions.face_uv": "Định dạng hiện tại hỗ trợ bản đồ UV trên mỗi khuôn mặt có thể xử lý kích thước khuôn mặt nhỏ. Vào \"Tệp\"> \"Dự án...\" và thay đổi \"Chế độ UV\" thành \"UV theo bề mặt\".",
	"dialog.plugins.outdated_client": "Yêu cầu phiên bản Blockbench mới hơn",
	"dialog.plugins.outdated_plugin": "Plugin đã lỗi thời và không hoạt động với phiên bản Blockbench này",
	"settings.motion_trails": "Đường chuyển động",
	"settings.motion_trails.desc": "Hiển thị các vệt chuyển động trong trình chỉnh sửa hoạt ảnh",
	"settings.antialiasing": "Khử răng cưa",
	"settings.antialiasing.desc": "Chuyển đổi khử răng cưa trong bản xem trước. Khởi động lại Blockbench để áp dụng các thay đổi",
	"action.timeline_frame_back": "Gửi lùi 1 khung hình",
	"action.timeline_frame_forth": "Gửi 1 khung về phía trước",
	"panel.bone.ik": "Động học nghịch đảo (Thử nghiệm)",
	"settings.particle_tick_rate": "Tỷ lệ đánh dấu hạt",
	"settings.particle_tick_rate.desc": "Tốc độ đánh dấu cho các hiệu ứng hạt tính bằng tích tắc trên giây. Mặc định là 30",
	"action.lock_motion_trail": "Khoá đường chuyển động",
	"action.lock_motion_trail.desc": "Khoá đường chuyển động vào nhóm hiện được chọn",
	"menu.animation_file.unload": "Dỡ bỏ tập tin",
	"data.null_object": "Đối tượng rỗng",
	"status_bar.toggle_sidebar": "Chuyển đổi thanh bên",
	"message.load_plugin_failed.title": "Không thể tải plugin",
	"message.load_plugin_failed.message": "Đảm bảo rằng tên tệp cơ sở của plugin khớp với ID plugin `%0`, như được chỉ định trong Plugin.register().",
	"dialog.project.uv_mode": "Chế độ UV",
	"dialog.project.uv_mode.box_uv": "Hộp UV",
	"dialog.project.uv_mode.face_uv": "UV theo bề mặt",
	"dialog.project.texture_size": "Kích thước kết cấu",
	"dialog.animation_export.title": "Chọn một hoạt ảnh để xuất",
	"dialog.create_texture.rearrange_uv": "Sắp xếp lại UV",
	"layout.color.subtle_text": "văn bản chi tiết",
	"layout.color.subtle_text.desc": "Màu chữ phụ có độ tương phản thấp",
	"settings.interface_scale": "Quy mô giao diện",
	"settings.interface_scale.desc": "Quy mô của toàn bộ giao diện Blockbench",
	"settings.background_rendering": "Kết xuất nền",
	"settings.background_rendering.desc": "Cập nhật bản xem trước trong khi cửa sổ không được chọn",
	"settings.ctrl_shift_size": "Control + Shift độ phân giải",
	"settings.ctrl_shift_size.desc": "Độ phân giải của lưới trong khi giữ Control và Shift",
	"settings.hardware_acceleration": "Tăng tốc phần cứng",
	"settings.hardware_acceleration.desc": "Thuê ngoài công việc dựng hình cho card đồ họa. Khởi động lại Blockbench để các thay đổi có hiệu lực",
	"action.explode_skin_model": "Chia mô hình skin",
	"action.explode_skin_model.desc": "Chuyển đổi chế độ xem bùng nổ cho phép bạn chỉnh sửa các mặt được che",
	"action.export_minecraft_skin": "Xuất skin Minecraft",
	"action.export_minecraft_skin.desc": "Xuất skin Minecraft dưới dạng kết cấu PNG",
	"action.add_null_object": "Thêm đối tượng rỗng",
	"action.add_null_object.desc": "Thêm đối tượng rỗng mới",
	"action.animated_texture_frame": "Khung kết cấu động",
	"action.animated_texture_frame.desc": "Đặt khung hiện tại của kết cấu động",
	"action.export_animation_file": "Xuất hoạt ảnh...",
	"action.export_animation_file.desc": "Xuất các hoạt ảnh đã chọn sang một tệp mới",
	"action.timeline_graph_editor": "Đổi trình sửa biểu đồ",
	"action.timeline_graph_editor.desc": "Chuyển đổi dòng thời gian giữa chế độ xem chỉnh sửa biểu đồ và chế độ xem khung hình chính",
	"menu.file.recent.clear": "Xóa các tệp gần đây",
	"switches.shade": "Đổ bóng",
	"generic.share": "Chia sẻ",
	"dates.minute": "%0 phút",
	"dates.minutes": "%0 phút",
	"dates.hour": "%0 giờ",
	"dates.hours": "%0 giờ",
	"dates.day": "%0 ngày",
	"dates.days": "%0 ngày",
	"dates.week": "%0 tuần",
	"dates.weeks": "%0 tuần",
	"dates.year": "%0 năm",
	"dates.years": "%0 năm",
	"message.installed_plugin": "Đã cài đặt thành công plugin %0",
	"message.installed_plugin_fail": "Không thể cài đặt plugin %0",
	"dialog.share_model.title": "Chia sẻ mô hình",
	"dialog.share_model.expire_time": "Thời gian hết hạn",
	"dialog.share_model.failed": "Không thể tải lên mô hình",
	"action.import_java_block_model": "Thêm mô hình khối/vật phẩm Java",
	"action.import_java_block_model.desc": "Thêm mô hình khối/vật phẩm Minecraft Java từ tệp json vào mô hình hiện tại",
	"action.share_model": "Chia sẻ...",
	"action.share_model.desc": "Tạo một liên kết ngắn để chia sẻ mô hình của bạn",
	"action.import_project": "Nhập dự án",
	"action.import_project.desc": "Nhập một dự án khác từ tệp .bbmodel vào dự án hiện tại",
	"dialog.toolbar_edit.hidden_tools": "Một số công cụ có thể bị ẩn vì chúng không khả dụng ở chế độ, định dạng hoặc tình huống hiện tại.",
	"settings.camera_near_plane": "Camera Near Plane",
	"settings.camera_near_plane.desc": "Khoảng cách tối thiểu từ máy ảnh mà tại đó các đối tượng được hiển thị. Giá trị cao hơn làm giảm Z-fight. Mặc định là 1.",
	"mode.start.keymap_preference.desc": "Nếu bạn chưa quen với Blockbench và đến từ một phần mềm 3D khác, bạn có thể chọn sơ đồ điều khiển để giúp bạn chuyển đổi dễ dàng hơn. Bạn có thể thay đổi sơ đồ bàn phím hoặc các tổ hợp phím riêng lẻ sau trong cài đặt.",
	"message.load_keymap": "Bạn có chắc chắn muốn tải sơ đồ bàn phím này không? Điều này sẽ ghi đè lên tổ hợp phím hiện tại của bạn.",
	"message.keymap_loaded": "Đã tải sơ đồ bàn phím",
	"dialog.convert_project.current_format": "Định dạng hiện tại",
	"dialog.create_texture.rearrange_uv.desc": "Tạo một cách sắp xếp UV mới để cho mọi mặt có vị trí riêng trên kết cấu",
	"dialog.create_texture.power.desc": "Khóa kích thước họa tiết tự động thành lũy thừa 2, chẳng hạn như 64 hoặc 128. Một số trình kết xuất yêu cầu điều này",
	"dialog.create_texture.double_use.desc": "Nếu hai phần tử đã được gán cùng một không gian UV, hãy giữ nguyên như vậy trong bản đồ mới",
	"dialog.create_texture.padding.desc": "Thêm phần đệm nhỏ giữa các phần riêng lẻ của mẫu",
	"dialog.create_texture.resolution.desc": "Chiều cao và chiều rộng của kết cấu",
	"dialog.create_gif.color": "Màu nền",
	"dialog.save_angle.zoom": "Phóng to",
	"dialog.skin.variant": "Biến thể",
	"dialog.flip_animation.info": "Các xương đối diện được xác định bằng các từ khóa 'trái' và 'phải' trong tên của chúng.",
	"dialog.export_private_settings.title": "Cài đặt riêng tư",
	"dialog.export_private_settings.message": "Tệp của bạn chứa thông tin riêng tư sau: **%0**. Bỏ qua các giá trị này nếu bạn định chia sẻ tệp với người khác.",
	"dialog.export_private_settings.keep": "Giữ",
	"settings.timecode_frame_number": "Hiển thị mã thời gian dưới dạng số khung",
	"settings.timecode_frame_number.desc": "Hiển thị mã thời gian phân số trong dòng thời gian dưới dạng số khung thay vì phần trăm giây",
	"settings.animation_sample_rate": "Tỷ lệ mẫu hoạt ảnh",
	"settings.animation_sample_rate.desc": "Tỷ lệ mẫu trên giây cho các đường cong vốn không hỗ trợ định dạng tương ứng",
	"keybind.preview_zoom": "Chế độ thu phóng",
	"action.gradient_tool": "Công cụ chuyển màu",
	"action.gradient_tool.desc": "Tạo một dải màu trên kết cấu của bạn",
	"action.import_settings": "Nhập cài đặt",
	"action.import_settings.desc": "Nhập tệp .bbsettings",
	"action.export_settings": "Xuất cài đặt",
	"action.export_settings.desc": "Xuất cài đặt Blockbench dưới dạng tệp .bbsettings",
	"action.load_keymap": "Tải sơ đồ bàn phím",
	"action.load_keymap.default": "Mặc định (Trackpad/Chuột)",
	"action.load_keymap.mouse": "Mặc định (Chuột)",
	"action.load_keymap.default.desc": "Các tổ hợp phím Blockbench mặc định, với các điều khiển điều hướng chế độ xem được tối ưu hóa để sử dụng trên trackpad của laptop",
	"action.load_keymap.mouse.desc": "Các tổ hợp phím Blockbench mặc định, với điều hướng chế độ xem được liên kết với nút chuột giữa",
	"action.load_keymap.blender.desc": "Sơ đồ bàn phím dành cho người đã quen với các điều khiển của Blender",
	"action.load_keymap.cinema4d.desc": "Sơ đồ bàn phím dành cho người dùng đã quen với cách điều khiển của Cinema 4D",
	"action.load_keymap.maya.desc": "Sơ đồ bàn phím dành cho người dùng quen thuộc với các điều khiển của Autodesk Maya",
	"action.import_keymap": "Nhập sơ đồ phím",
	"action.import_keymap.desc": "Nhập tổ hợp phím từ tệp .bbkeymap",
	"action.export_keymap": "Xuất sơ đồ bàn phím",
	"action.export_keymap.desc": "Xuất các tổ hợp phím hiện tại dưới dạng tệp .bbkeymap",
	"action.edit_history": "Chỉnh lịch sử...",
	"action.edit_history.desc": "Xem lịch sử chỉnh sửa và hoàn tác hoặc làm lại các bước",
	"action.group_elements": "Nhóm yếu tố",
	"action.group_elements.desc": "Gói các phần tử đã chọn vào một nhóm mới",
	"action.unfold_groups": "Mở rộng nhóm",
	"action.unfold_groups.desc": "Mở rộng tất cả các nhóm trong kế hoạch",
	"action.edit_bedrock_binding": "Chỉnh sửa liên kết...",
	"action.edit_bedrock_binding.desc": "Thay đổi hình học được liên kết với xương nào",
	"action.pick_screen_color": "Chọn màu màn hình",
	"action.pick_screen_color.desc": "Chọn một màu từ đâu đó trên màn hình của bạn",
	"action.view_mode": "Chế độ xem",
	"action.view_mode.desc": "Thay đổi chế độ xem mô hình",
	"action.view_mode.textured": "Kết cấu",
	"action.view_mode.solid": "Chất rắn",
	"action.view_mode.wireframe": "Khung dây",
	"action.toggle_sidebars": "Chuyển đổi thanh bên",
	"action.toggle_sidebars.desc": "Kích hoạt hoặc tắt các thanh bên",
	"action.set_animation_end": "Đặt kết thúc hoạt ảnh",
	"action.set_animation_end.desc": "Đặt phần cuối của hoạt ảnh đã chọn thành thời gian dòng thời gian hiện tại",
	"action.flip_animation": "Lật hoạt ảnh",
	"action.flip_animation.desc": "Lật một phần của hoạt ảnh bằng cách sao chép các khung hình chính đã chọn sang phía bên kia của mô hình",
	"action.graph_editor_zero_line": "Bao gồm dòng 0",
	"action.graph_editor_zero_line.desc": "Trình chỉnh sửa biểu đồ có luôn bao gồm đường số 0 trong chế độ xem hay không",
	"menu.texture.render_mode": "Chế độ kết xuất",
	"menu.texture.render_mode.emissive": "Phát quang",
	"menu.texture.render_mode.layered": "Nhiều lớp",
	"menu.preview.angle.edit": "Chỉnh góc nhìn...",
	"menu.animation.start_delay": "Độ trễ bắt đầu",
	"menu.animation.loop_delay": "Độ trễ vòng lặp",
	"menu.animation.flip_keyframes": "Lật khung hình chính",
	"menu.mobile_keyboard.disable_all": "Tắt tất cả",
	"panel.keyframe.toggle_uniform_scale": "chuyển đổi kích thước thống nhất",
	"camera_angle.common_isometric_right": "Hình chiếu trục đo phải(2:1)",
	"camera_angle.common_isometric_left": "Hình chiếu trục đo trái(2:1)",
	"camera_angle.true_isometric_right": "Hình chiếu trục đo phải đúng(30°)",
	"camera_angle.true_isometric_left": "Hình chiếu trục đo trái đúng(30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Cập nhật lên bản phát hành trước",
	"settings.update_to_prereleases.desc": "Tự động cập nhật lên các phiên bản beta của Blockbench để kiểm tra các tính năng mới. Các phiên bản trước khi phát hành có thể không ổn định, không bật tùy chọn này nếu bạn dùng Blockbench cho công việc hoặc các dự án quan trọng khác.",
	"data.separator.spacer": "Đệm",
	"data.separator.linebreak": "Ngắt dòng",
	"data.setting": "Cài đặt",
	"generic.select_all": "Chọn tất cả",
	"generic.select_none": "Từ chối",
	"projects.new_tab": "Thẻ mới",
	"projects.close_tab": "Đóng thẻ",
	"message.invalid_format.title": "Định dạng không hợp lệ",
	"message.invalid_format.message": "Mô hình này được tạo ở định dạng '%0', định dạng này không có sẵn trong cài đặt Blockbench của bạn. Rất có thể bạn cần một plugin cụ thể để mở nó một cách chính xác.",
	"message.invalid_link": "Liên kết mô hình không hợp lệ hoặc hết hạn",
	"message.default_textures.current": "Đường dẫn hiện tại",
	"message.update_after_restart": "Bản cập nhật này sẽ được cài đặt sau lần khởi động tiếp theo",
	"message.copy_paste_tool_viewport": "Công cụ này chỉ có thể được sử dụng trong bảng UV",
	"dialog.project.shadow_size": "Kích thước bóng",
	"dialog.find_replace.target": "Mục tiêu",
	"dialog.find_replace.target.element_names": "Tên yếu tố",
	"dialog.find_replace.target.group_names": "Tên nhóm",
	"dialog.find_replace.target.animation_names": "Tên hoạt ảnh",
	"dialog.find_replace.target.keyframe_values": "Giá trị khung hình chính",
	"dialog.find_replace.find": "Tìm",
	"dialog.find_replace.replace": "Thay thế",
	"dialog.find_replace.regex": "Biểu hiện thông thường",
	"dialog.add_primitive.shape": "Hình dạng",
	"dialog.add_primitive.shape.circle": "Hình tròn",
	"dialog.add_primitive.shape.tube": "Hình ống",
	"dialog.add_primitive.shape.cone": "Hình nón",
	"dialog.add_primitive.shape.cylinder": "Hình trụ",
	"dialog.add_primitive.shape.sphere": "Hình cầu",
	"dialog.add_primitive.shape.torus": "Hình xuyến",
	"dialog.add_primitive.shape.cube": "Hình khối",
	"dialog.add_primitive.shape.pyramid": "Hình chóp",
	"dialog.add_primitive.diameter": "Đường kính",
	"dialog.add_primitive.height": "Chiều cao",
	"dialog.add_primitive.sides": "Số mặt bên",
	"dialog.add_primitive.minor_diameter": "Độ dày",
	"dialog.add_primitive.minor_sides": "Bên nhỏ",
	"dialog.create_texture.combine_polys": "liên kết bề mặt",
	"dialog.create_texture.combine_polys.desc": "Kết hợp các mặt phẳng được kết nối thành một phần UV",
	"dialog.model_stats.meshes": "Khung lưới",
	"dialog.export_private_settings.omit": "Bỏ qua",
	"layout.select": "Chọn",
	"layout.options": "Tùy chọn",
	"layout.color": "Bảng màu",
	"layout.documentation": "Tài liệu",
	"layout.color.bright_ui_text": "Văn bản UI sáng",
	"layout.color.bright_ui_text.desc": "Văn bản trên nền sáng",
	"layout.name": "Tên",
	"layout.author": "Tác giả",
	"settings.dialog.desc": "Hiện hộp thoại \"%0\"",
	"settings.export_empty_groups": "Xuất các nhóm trống",
	"settings.export_empty_groups.desc": "Bao gồm các nhóm không có nội dung trong các tệp đã xuất",
	"category.separators": "Dải phân cách",
	"keybind.preview_area_select": "Khu vực Chọn",
	"action.color_erase_mode": "Chế độ xóa",
	"action.color_erase_mode.desc": "Khi bật chế độ xóa, các công cụ như Tô màu và Hình chữ nhật sẽ trừ màu thay vì thêm chúng",
	"action.open_from_link": "Mở mô hình từ liên kết...",
	"action.open_from_link.desc": "Mở mô hình từ URL blckbn.ch",
	"action.import_obj": "Nhập mô hình OBJ",
	"action.import_obj.desc": "Nhập các đối tượng từ mô hình OBJ dưới dạng khung lưới",
	"action.add_plugin": "Cài đặt plugin",
	"action.add_plugin.desc": "Cài đặt plugin từ kiểm soát hành động",
	"action.remove_plugin": "Xóa plugin khỏi kiểm soát hành động",
	"action.remove_plugin.desc": "Gỡ cài đặt plugin thông qua Kiểm soát hành động",
	"action.add_mesh": "Thêm lưới",
	"action.add_mesh.desc": "Thêm một khung lưới mới",
	"action.add_texture_mesh": "Thêm lưới kết cấu",
	"action.add_texture_mesh.desc": "Thêm một khung lưới kết cấu mới",
	"action.find_replace": "Tìm/Thay thế...",
	"action.find_replace.desc": "Tìm và thay thế các phần của tên",
	"action.hide_everything_except_selection": "Ẩn mọi thứ (trừ phần lựa chọn)",
	"action.hide_everything_except_selection.desc": "Chuyển đổi chế độ hiển thị cho tất cả các phần tử ngoại trừ phần tử đã chọn",
	"action.transform_space.normal": "Bình thường",
	"action.selection_mode": "Chế độ lựa chọn",
	"action.selection_mode.desc": "Thay đổi cách các phần tử có thể được chọn trong chế độ xem",
	"action.selection_mode.object": "Vật",
	"action.selection_mode.face": "Bề mặt",
	"action.selection_mode.vertex": "Đỉnh",
	"action.create_face": "Tạo mặt hoặc cạnh",
	"action.create_face.desc": "Tạo một mặt hoặc cạnh mới giữa các đỉnh đã chọn",
	"action.convert_to_mesh": "Chuyển đổi thành khung lưới",
	"action.convert_to_mesh.desc": "Chuyển đổi các phần tử đã chọn thành khung lưới",
	"action.invert_face": "Đảo ngược mặt",
	"action.invert_face.desc": "Đảo ngược các mặt đã chọn để làm cho chúng quay về hướng ngược lại",
	"action.extrude_mesh_selection": "Chọn đùn",
	"action.extrude_mesh_selection.desc": "Đùn các phần đã chọn của khung lưới",
	"action.loop_cut": "Cắt vòng",
	"action.loop_cut.desc": "Chia khung lưới thành một vòng trên cạnh đã chọn",
	"action.merge_meshes": "Hợp nhất khung lưới",
	"action.merge_meshes.desc": "Hợp nhất nhiều khung lưới thành một",
	"action.keyframe_uniform": "Tỷ lệ thống nhất",
	"action.keyframe_uniform.desc": "Cho phép chia tỷ lệ đồng đều trên các khung hình chính đã chọn",
	"menu.locator.ignore_inherited_scale": "Bỏ qua quy mô kế thừa",
	"menu.texture.elements": "Áp dụng cho các yếu tố",
	"uv_editor.transparent_face": "Mặt trong suốt",
	"display.pose_angle": "Góc tạo dáng (Chỉ dành cho bản xem trước)",
	"data.mesh": "Khung lưới",
	"dialog.create_texture.type": "Kiểu",
	"dialog.create_texture.type.blank": "Trống",
	"dialog.create_texture.type.template": "Mẫu kết cấu",
	"dialog.create_texture.type.color_map": "Mẫu màu đặc",
	"dialog.sketchfab_uploader.suggested_tags": "Thẻ được đề xuất",
	"dialog.sketchfab_uploader.category": "Thể loại",
	"dialog.sketchfab_uploader.category2": "Thể loại 2",
	"layout.restore_backup": "Chủ đề tùy chỉnh của bạn \"%0\" đã bị ghi đè. Nhấn vào đây để khôi phục nó.",
	"layout.borders": "Đường viền",
	"action.fill_mode.element": "Yếu tố",
	"action.inset_mesh_selection": "Lựa chọn đầu vào",
	"action.inset_mesh_selection.desc": "Chèn các phần đã chọn của khung lưới",
	"action.dissolve_edges": "Hòa tan các cạnh",
	"action.dissolve_edges.desc": "Hòa tan các cạnh đã chọn trong khung lưới và hợp nhất các mặt mà chúng phân chia",
	"action.split_mesh": "Chia khung lưới",
	"action.split_mesh.desc": "Tách các mặt đã chọn của khung lưới thành một khung lưới mới",
	"action.merge_vertices": "Hợp nhất các đỉnh",
	"action.merge_vertices.desc": "Hợp nhất các đỉnh đã chọn vào vị trí của đỉnh được chọn đầu tiên",
	"action.view_mode.normal": "Mặt thường",
	"action.snap_uv_to_pixels": "Khớp UV với điểm ảnh",
	"action.snap_uv_to_pixels.desc": "Gắn các đỉnh UV đã chọn vào lưới điểm ảnh",
	"menu.file.import.import_open_project": "Nhập dự án mở",
	"menu.help.unlock_projects": "Mở khóa tất cả các dự án",
	"status_bar.selection.faces": "%0 mặt",
	"status_bar.selection.vertices": "%0 đỉnh",
	"message.merged_vertices": "Đã tìm thấy và hợp nhất %0 đỉnh ở %1 vị trí",
	"settings.vertex_merge_distance": "Khoảng cách hợp nhất đỉnh",
	"settings.vertex_merge_distance.desc": "Khoảng cách trong đó các đỉnh được hợp nhất bằng cách hợp nhất theo khoảng cách",
	"settings.show_only_selected_uv": "Chỉ hiển thị UV đã chọn",
	"settings.show_only_selected_uv.desc": "Theo mặc định, chỉ hiển thị các mặt UV đã chọn trong trình chỉnh sửa UV",
	"action.merge_vertices.merge_all": "Hợp nhất tất cả",
	"action.merge_vertices.merge_all_in_center": "Hợp nhất tất cả vào trung tâm",
	"action.merge_vertices.merge_by_distance": "Hợp nhất theo khoảng cách",
	"action.merge_vertices.merge_by_distance_in_center": "Hợp nhất theo khoảng cách từ trung tâm",
	"action.uv_rotate_left": "Xoay UV sang trái",
	"action.uv_rotate_left.desc": "Xoay mặt UV đã chọn ngược chiều kim đồng hồ",
	"action.uv_rotate_right": "Xoay UV sang phải",
	"action.uv_rotate_right.desc": "Xoay mặt UV đã chọn theo chiều kim đồng hồ",
	"menu.uv.display_uv": "Hiển thị UV",
	"menu.uv.display_uv.selected_faces": "Mặt được chọn",
	"menu.uv.display_uv.selected_elements": "Tất cả mặt",
	"menu.uv.display_uv.all_elements": "Tất cả mặt trên tất cả các yếu tố",
	"menu.paste.face": "Mặt UV",
	"menu.paste.mesh_selection": "Lựa chọn lưới",
	"menu.paste.outliner": "Yếu tố",
	"uv_editor.show_all_faces": "Hiển thị tất cả mặt",
	"uv_editor.show_selected_faces": "Hiển thị các mặt đã chọn",
	"status_bar.selection.edges": "%0 Cạnh",
	"action.selection_mode.edge": "Cạnh",
	"message.cannot_re_import.title": "Không thể nhập lại mô hình",
	"message.cannot_re_import.message": "Không thể nhập lại định dạng mô hình đã xuất vào Blockbench. Vui lòng đảm bảo lưu mô hình của bạn dưới dạng tệp dự án.",
	"generic.default": "Mặc định",
	"units.pixels_per_meter": "%0 điểm ảnh trên mỗi mét",
	"mode.pose": "Tư thế",
	"modifier_actions.resize_both_sides": "Thay đổi kích thước theo cả hai hướng",
	"modifier_actions.resize_one_side": "Thay đổi kích thước theo một hướng",
	"modifier_actions.draw_line": "Vẽ đường thẳng",
	"modifier_actions.drag_without_snapping": "Kéo và thả",
	"modifier_actions.stretch_keyframes": "Kéo dài khung hình chính",
	"modifier_actions.resize_background": "Thay đổi kích thước nền",
	"modifier_actions.select_multiple": "Chọn nhiều",
	"modifier_actions.select_range": "Chọn phạm vi",
	"modifier_actions.drag_to_duplicate": "Kéo để sao chép",
	"modifier_actions.uniform_scaling": "Tỷ lệ thống nhất",
	"modifier_actions.snap_direction": "Định hướng",
	"message.no_valid_elements": "Không có yếu tố hợp lệ được chọn...",
	"dialog.add_primitive.shape.plane": "Mặt phẳng",
	"dialog.save_angle.rotation_mode": "Chế độ quay",
	"dialog.save_angle.rotation": "Quay",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Tự động ẩn thanh tab",
	"settings.hide_tab_bar.desc": "Ẩn thanh tab khi chỉ mở một tab",
	"settings.status_bar_modifier_keys": "Đề xuất các phím bổ trợ trên thanh trạng thái",
	"settings.status_bar_modifier_keys.desc": "Hiển thị các phím bổ trợ được đề xuất theo ngữ cảnh trong thanh trạng thái",
	"settings.ground_plane": "Mặt phẳng sàn",
	"settings.ground_plane.desc": "Hiển thị một mặt phẳng sàn bên dưới mô hình",
	"settings.preview_paste_behavior": "Hành vi xem trước dán mặc định",
	"settings.preview_paste_behavior.desc": "Chọn hành vi khi dán nội dung nào đó vào bản xem trước trong chế độ Chỉnh sửa và có sẵn nhiều tùy chọn",
	"settings.preview_paste_behavior.always_ask": "Luôn luôn hỏi",
	"action.new_window": "Cửa sổ mới",
	"action.new_window.desc": "Mở một cửa sổ Blockbench mới",
	"action.export_collada": "Xuất mô hình Collada (dae)",
	"action.export_collada.desc": "Xuất mô hình và hoạt ảnh dưới dạng tệp dae để sử dụng nó trong các ứng dụng 3D khác",
	"action.paint_mode_uv_overlay": "Lớp phủ UV",
	"action.paint_mode_uv_overlay.desc": "Hiển thị bản đồ UV dưới dạng lớp phủ trong chế độ sơn",
	"action.bake_animation_into_model": "Đưa hoạt ảnh vào mô hình",
	"action.bake_animation_into_model.desc": "Đưa khung hoạt ảnh hiện đang hiển thị vào mô hình. Chỉ áp dụng xoay và vị trí, bỏ qua tỷ lệ.",
	"action.keyframe_interpolation.step": "Bước",
	"action.set_ik_target": "Đặt mục tiêu IK",
	"action.set_ik_target.desc": "Chọn xương mục tiêu sẽ di chuyển đến đối tượng rỗng này thông qua Động học nghịch đảo",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Góc camera",
	"menu.action_control.recent_in_streamer_mode": "Chắc chắn? Chế độ truyền phát được bật",
	"menu.action_control.recent_in_streamer_mode.desc": "Bạn có chắc chắn muốn hiển thị các mẫu gần đây không?",
	"menu.tools": "Công cụ",
	"menu.file.recent.more": "Xem thêm...",
	"menu.null_object.lock_ik_target_rotation": "Khóa xoay mục tiêu IK",
	"menu.animation_file.import_remaining": "Nhập các hoạt ảnh còn lại",
	"edit.loop_cut.offset": "Bù lại",
	"edit.extrude_mesh_selection.extend": "Gia Han",
	"cube.color.pink": "Hồng",
	"cube.color.silver": "Màu bạc",
	"dialog.plugins.offline": "Không có kết nối Internet",
	"dialog.create_texture.pixel_density": "Mật độ điểm ảnh",
	"dialog.create_texture.pixel_density.desc": "Mật độ điểm ảnh của kết cấu, tính bằng pixel trên mét. Kích thước của bản đồ kết cấu có thể khác nhau tùy thuộc vào số lượng và kích thước của các phần tử.",
	"panel.skin_pose": "Tư thế",
	"panel.skin_pose.none": "không có",
	"panel.skin_pose.natural": "Thiên nhiên",
	"panel.skin_pose.walking": "Đi dạo",
	"panel.skin_pose.crouching": "Cúi người",
	"panel.skin_pose.sitting": "Ngồi",
	"panel.skin_pose.jumping": "Nhảy",
	"panel.skin_pose.aiming": "Nhắm mục tiêu",
	"edit.loop_cut.direction": "Phương hướng",
	"data.texture_mesh": "kết cấu khung lưới",
	"generic.left": "Trái",
	"generic.right": "Phải",
	"mode.start.quick_setup": "Cài đặt nhanh",
	"mode.start.keymap": "Sơ đồ phím",
	"mode.start.quick_setup.more_themes": "Hơn...",
	"dialog.resize_texture.animation_frames": "khung hình hoạt ảnh",
	"dialog.export_emission_map.title": "Xuất bản đồ emission",
	"dialog.export_emission_map.format": "Định dạng",
	"dialog.export_emission_map.format.luminance": "Độ sáng",
	"dialog.export_emission_map.format.luminance_inverted": "Độ sáng đảo ngược",
	"dialog.export_emission_map.format.colors": "Màu",
	"dialog.export_emission_map.threshold": "Ngưỡng minh bạch",
	"dialog.export_emission_map.round_up": "Làm tròn lên tới %0 x %1",
	"dialog.export_emission_map.flip_y": "Lật trục Y",
	"dialog.select.type": "Loại yếu tố",
	"dialog.create_texture.max_edge_angle": "Ngưỡng góc cạnh",
	"dialog.create_texture.max_edge_angle.desc": "Góc tối đa giữa hai mặt mà tại đó chúng vẫn sẽ được kết hợp",
	"dialog.create_texture.max_island_angle": "Ngưỡng góc bề mặt",
	"dialog.create_texture.max_island_angle.desc": "Góc tối đa có thể liên kết với cùng một bề mặt UV",
	"settings.mobile_panel_side": "Bên bảng điều khiển di động",
	"settings.mobile_panel_side.desc": "Chọn phía nào của bảng điều khiển màn hình được hiển thị khi sử dụng Blockbench ở hướng ngang",
	"settings.obj_face_export_mode": "Chế độ xuất mặt OBJ",
	"settings.obj_face_export_mode.desc": "Chọn để chuyển đổi tất cả các bề mặt thành ba hoặc bốn trong xuất OBJ",
	"settings.obj_face_export_mode.both": "Mặc định",
	"settings.obj_face_export_mode.tris": "Chuyển đổi sang Tris",
	"settings.obj_face_export_mode.quads": "Chuyển đổi sang Quads",
	"action.seam_tool": "Công cụ khâu",
	"action.seam_tool.desc": "Công cụ xác định khâu UV cho các cạnh khung lưới",
	"action.resolve_group": "Giải quyết nhóm",
	"action.resolve_group.desc": "Giải quyết nhóm trong khi vẫn giữ các phần tử con của nó ở cùng một nơi",
	"action.move_to_group": "Di chuyển đến Nhóm",
	"action.move_to_group.desc": "Di chuyển các phần tử đã chọn sang một nhóm khác",
	"action.select_seam": "Chọn đường khâuUV",
	"action.select_seam.desc": "Chọn chế độ đường may UV cho các cạnh đã chọn",
	"action.select_seam.auto": "Tự động",
	"action.select_seam.join": "Tham gia",
	"action.select_seam.divide": "Chia",
	"action.adjust_brightness_contrast": "Điều chỉnh độ sáng&độ tương phản...",
	"action.adjust_brightness_contrast.desc": "Điều chỉnh độ sáng và độ tương phản của kết cấu đã chọn",
	"action.adjust_saturation_hue": "Điều chỉnh độ bão hoà và tông màu...",
	"action.adjust_saturation_hue.desc": "Điều chỉnh độ bão hoà và tông màu của kết cấu đã chọn",
	"action.invert_colors": "Đảo ngược màu sắc",
	"action.invert_colors.desc": "Đảo ngược tất cả các màu của kết cấu đã chọn",
	"action.adjust_curves": "Điều chỉnh đường cong...",
	"action.adjust_curves.desc": "Điều chỉnh các đường cong độ sáng của kết cấu đã chọn",
	"action.flip_texture_x": "Lật kết cấu theo chiều ngang",
	"action.flip_texture_y": "Lật kết cấu theo chiều dọc",
	"action.resize_texture": "Thay đổi kích thước kết cấu...",
	"action.view_mode.uv": "Xem trước UV",
	"action.append_to_template": "Nối các phần tử vào mẫu...",
	"action.append_to_template.desc": "Thêm các phần tử hiện được chọn vào mẫu kết cấu",
	"action.move_texture_with_uv": "Di chuyển kết cấu bằng UV",
	"action.move_texture_with_uv.desc": "Di chuyển kết cấu của mặt khi kéo mặt UV",
	"action.timeline_setups": "Thiết lập dòng thời gian",
	"action.save_timeline_setup": "Lưu thiết lập dòng thời gian...",
	"action.save_timeline_setup.desc": "Lưu giá trị cài sẵn cho các hoạt ảnh và kênh hiện được chọn",
	"menu.texture": "Kết cấu",
	"menu.texture.render_mode.default": "Mặc định",
	"menu.texture.merge_onto_texture": "Hợp nhất vào kết cấu ở trên",
	"menu.animation.unload": "Dỡ",
	"panel.timeline": "Mốc thời gian",
	"action.pan_tool": "Công cụ Pan",
	"action.pan_tool.desc": "Công cụ điều hướng trong chế độ xem và trình chỉnh sửa kết cấu",
	"mode.start.recent.favorite": "Đánh dấu là yêu thích",
	"mode.start.info": "Thông tin",
	"mode.start.target": "Mục tiêu",
	"mode.start.start": "Bắt đầu",
	"mode.start.create_new": "Tạo mô hình mới",
	"mode.start.format.informations": "Tốt để biết:",
	"mode.start.format.resources": "Tài nguyên:",
	"format.free.info.meshes": "Định dạng này cho phép xây dựng các mô hình đa giác thấp bằng cách sử dụng các hình khối và khung lưới có hình dạng tùy chỉnh.",
	"format.free.info.limitation": "Không thể tải mô hình vào các trò chơi cần định dạng chuyên biệt, chẳng hạn như Minecraft.",
	"format.skin.info.skin": "Định dạng này được thiết kế để tạo giao diện và kết cấu thực thể cho Minecraft.",
	"format.skin.info.model": "Không thể thay đổi mô hình. Để thay đổi mô hình, trước tiên hãy chuyển đổi sang định dạng khác thông qua **Tệp** > **Chuyển đổi dự án**.",
	"format.java_block.info.rotation": "Xoay được giới hạn ở các bước 22,5 độ và một trục xoay cho mỗi phần tử",
	"format.java_block.info.size": "Mô hình được giới hạn ở kích thước 3x3x3 khối. Cài đặt hiển thị có thể làm cho mô hình vật phẩm lớn hơn",
	"format.java_block.info.animation": "Định dạng này không hỗ trợ hoạt ảnh trong vanilla Minecraft. Nếu bạn đang tạo một bản mod, bạn có thể sử dụng GeckoLib để tạo hoạt ảnh cho mô hình của mình. Mặt khác, cách duy nhất để tạo hoạt ảnh là chuyển đổi mô hình bằng lệnh hoặc họa tiết động.",
	"format.bedrock.info.textures": "Mỗi mô hình chỉ có thể có một kết cấu",
	"format.bedrock_block": "Khối Bedrock",
	"format.bedrock_block.desc": "Mô hình khối cho Minecraft bản Bedrock",
	"format.modded_entity.info.integer_size": "Kích thước của các khối riêng lẻ được giới hạn ở số nguyên.",
	"format.modded_entity.info.format": "Các mô hình được viết bằng mã Java thay vì cấu trúc dữ liệu chuyên dụng như tất cả các định dạng xuất Blockbench khác.",
	"format.optifine_entity.info.optifine_required": "Người dùng không cài đặt OptiFine sẽ không thấy mô hình.",
	"format.optifine_entity.info.pivots": "Tâm quay của phần xương bị khóa, tốt nhất bạn không nên chạm vào nó.",
	"format_category.low_poly": "Đa giác thấp",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Khác",
	"format_category.loaders": "Trình tải",
	"message.recover_backup.recover": "Khôi phục",
	"message.invalid_characters.title": "Đường dẫn không hợp lệ",
	"message.invalid_characters.message": "Đường dẫn của tệp đã nhập chứa các ký tự, chữ hoa hoặc khoảng trắng không hợp lệ. Các ký tự được hỗ trợ là: %0",
	"dialog.share_model.thumbnail": "Hình thu nhỏ",
	"dialog.skin.high_res_texture": "Xin lưu ý rằng giao diện có độ phân giải đã chọn sẽ không hoạt động như giao diện Minecraft thông thường. Chọn độ phân giải thấp hơn.",
	"settings.allow_display_slot_mirror": "Cho phép phản chiếu các khe hiển thị",
	"settings.allow_display_slot_mirror.desc": "Bạn có thể phản chiếu các vị trí hiển thị của các mô hình vật phẩm Java. CẢNH BÁO: Điều này chỉ hoạt động cho Minecraft 1.14 trở về trước hoặc trong các trường hợp đặc biệt.",
	"action.switch_tabs": "Chuyển tab",
	"action.switch_tabs.desc": "Chuyển đến các tab đang mở của bạn. Bạn có thể di chuyển theo hướng ngược lại bằng cách nhấn shift",
	"action.unselect_all": "Bỏ chọn tất cả",
	"action.save_palette": "Lưu bảng màu...",
	"action.save_palette.desc": "Lưu bảng màu hiện tại vào Blockbench để sử dụng sau",
	"action.keyframe_column_create": "Tạo cột khung hình chính",
	"action.keyframe_column_create.desc": "Nếu khung hình chính đã tồn tại, hãy nhập tất cả các kênh trong dòng thời gian vào mã thời gian hiện tại.",
	"action.keyframe_column_select": "Chọn cột khung hình chính",
	"action.keyframe_column_select.desc": "Chọn tất cả các khung hình chính trong dòng thời gian dọc theo cột bên dưới đầu phát",
	"menu.uv": "UV",
	"menu.keyframe": "Khung hình chính",
	"menu.palette.load.update": "Cập nhật bảng màu",
	"menu.palette.load.update.desc": "Cập nhật bảng này với các màu của bảng Blockbench hiện tại",
	"menu.timeline_marker.set_time": "Cài đặt thời gian...",
	"uv_editor.scale_uv": "quy mô UV",
	"action.preview_scene": "Cảnh xem trước",
	"action.preview_scene.desc": "Thay đổi cảnh xem trước mô hình",
	"preview_scene.minecraft_overworld": "Minecraft Overworld",
	"preview_scene.minecraft_nether": "Minecraft Nether",
	"preview_scene.minecraft_end": "Minecraft End",
	"dialog.project.modded_entity_flip_y": "Lật trục Y",
	"preview_scene.studio": "Studio",
	"format.image": "Hình ảnh",
	"modifier_actions.set_copy_source": "Đặt nguồn sao chép",
	"message.load_images.title": "Tải hình ảnh",
	"message.load_images.edit_image": "Chỉnh sửa hình ảnh",
	"dialog.add_primitive.align_edges": "Căn chỉnh các cạnh",
	"dialog.flip_animation.show_in_timeline": "Hiển thị các xương đã sửa đổi trong dòng thời gian",
	"settings.default_cube_size": "Kích thước khối",
	"settings.default_cube_size.desc": "Đặt kích thước khối mặc định khi tạo khối mới",
	"settings.uniform_keyframe": "Các khung hình chính có cùng kích thước",
	"settings.uniform_keyframe.desc": "Đặt kích thước của khung hình chính về cùng kích thước theo mặc định",
	"settings.nearest_rectangle_select": "Chọn hình chữ nhật: Cạnh gần nhất",
	"settings.nearest_rectangle_select.desc": "Gắn các lựa chọn hình chữ nhật vào cạnh điểm ảnh gần nhất, như trong GIMP, thay vì toàn bộ điểm ảnh.",
	"settings.pick_color_opacity": "Chọn độ mờ màu",
	"settings.pick_color_opacity.desc": "Chọn độ mờ màu bằng thuốc nhỏ mắt và đặt nó làm độ mờ của cọ vẽ",
	"settings.paint_with_stylus_only": "Chỉ vẽ bằng bút stylus",
	"settings.paint_with_stylus_only.desc": "Chỉ sử dụng bút stylus để vẽ, giới hạn chuột hoặc nhập liệu bằng cảm ứng.",
	"action.copy_brush_mode": "Sao chép chế độ cọ vẽ",
	"action.copy_brush_mode.copy": "Sao chép",
	"action.copy_brush_mode.pattern": "Mẫu",
	"action.copy_brush_mode.sample": "Vật mẫu",
	"action.brush_shape": "Hình dạng cọ",
	"action.brush_shape.square": "Quảng trường",
	"action.brush_shape.circle": "Vòng tròn",
	"action.blend_mode": "Chế độ hòa trộn",
	"action.blend_mode.default": "Mặc định",
	"action.blend_mode.set_opacity": "Đặt độ mờ",
	"action.blend_mode.color": "Màu",
	"action.blend_mode.behind": "Phía sau",
	"action.blend_mode.multiply": "Nhân lên",
	"action.blend_mode.divide": "Chia",
	"action.blend_mode.add": "Thêm",
	"action.blend_mode.subtract": "Màn",
	"action.blend_mode.screen": "Màn hình",
	"action.blend_mode.overlay": "Lớp phủ",
	"action.blend_mode.hard_light": "Ánh sáng cứng",
	"action.blend_mode.difference": "Khác biệt",
	"action.copy_brush": "Sao chép cọ vẽ",
	"action.copy_brush.desc": "Nhân đôi một phần của kết cấu bằng cọ vẽ hoặc vẽ một mẫu.  Giữ phím Ctrl và nhấp chọn nơi cần sao chép.",
	"action.validator_window": "Xem các vấn đề về mô hình...",
	"action.validator_window.desc": "Mở trình xác thực liệt kê các sự cố trong mô hình hiện tại.",
	"action.cancel_gif": "Hủy GIF",
	"menu.text_edit.copy_vector": "Sao chép Véc tơ",
	"menu.brush_presets.dialog": "Giá trị cài sẵn cọ vẽ...",
	"menu.brush_presets.pixel_brush": "Cọ vẽ điểm ảnh",
	"menu.brush_presets.smooth_brush": "Cọ vẽ mịn",
	"menu.texture.edit_in_blockbench": "Chỉnh sửa trong Blockbench",
	"menu.mirror_painting.axis": "Trục",
	"menu.mirror_painting.axis.desc": "Chọn vẽ trên trục nào sẽ được nhân đôi",
	"menu.mirror_painting.global": "Đối xứng tổng thể",
	"menu.mirror_painting.global.desc": "Kích hoạt gương vẽ trên mô hình trong không gian tổng thể",
	"menu.mirror_painting.local": "Đối xứng cục bộ",
	"menu.mirror_painting.local.desc": "Kích hoạt gương trong không gian cục bộ cho từng phần tử",
	"menu.mirror_painting.texture_frames": "khung kết cấu hoạt ảnh",
	"menu.mirror_painting.texture_frames.desc": "Phản chiếu các nét vẽ cho mọi khung hình của kết cấu động",
	"format.bedrock_block.info.size_limit": "Kích thước tổng thể của khối kích thước được giới hạn ở 30 điểm ảnh ở mọi nơi. Các giới hạn có thể lệch tâm theo bất kỳ hướng nào bằng 7 điểm ảnh tính từ tâm của khối.",
	"format.bedrock_block.info.textures": "Nhiều kết cấu có thể được áp dụng cho các khối khác nhau trong Blockbench, nhưng yêu cầu thiết lập bổ sung trong gói hành vi để hoạt động chính xác trong trò chơi.",
	"format.image.desc": "Chỉnh sửa ảnh trong trình chỉnh sửa ảnh 2D",
	"generic.delete_all": "Xóa hết",
	"message.child_model_only.open": "Mở phụ huynh",
	"message.child_model_only.open_with_textures": "Mở phụ huynh và áp dụng kết cấu",
	"dialog.project.credit": "Credit",
	"dialog.convert_project.create_copy": "Tạo bản sao",
	"dialog.texture.frame_time": "Khung thời gian",
	"dialog.texture.frame_time.desc": "Đặt khoảng thời gian mỗi khung hình sẽ hiển thị, tính bằng tích tắc. Mỗi tích tắc là 1/20 giây.",
	"dialog.texture.frame_interpolate": "Nội suy",
	"dialog.texture.frame_interpolate.desc": "Nội suy giữa các khung hoạt ảnh bằng cách làm mờ chéo sang khung tiếp theo",
	"dialog.texture.frame_order_type": "Chế độ lặp",
	"dialog.texture.frame_order_type.loop": "Lặp",
	"dialog.texture.frame_order_type.backwards": "Vòng lặp ngược",
	"dialog.texture.frame_order_type.back_and_forth": "Lặp đi lặp lại",
	"dialog.texture.frame_order_type.custom": "Thứ tự tùy chỉnh",
	"dialog.texture.frame_order": "Thứ tự khung",
	"dialog.texture.frame_order.desc": "Đặt thứ tự khung tùy chỉnh bằng cách liệt kê các chỉ số khung hình theo thứ tự mới. Chỉ số khung hình bắt đầu từ 0 với khung đầu tiên.",
	"dialog.select.mode": "Chế độ",
	"dialog.select.mode.new": "Chọn mới",
	"dialog.select.mode.add": "Thêm vào Đã chọn",
	"dialog.select.mode.remove": "Xóa khỏi Đã chọn",
	"dialog.select.mode.in_selection": "Chỉ chọn từ Đã chọn",
	"dialog.predicate_overrides.model": "Mô hình",
	"dialog.predicate_overrides.predicates": "Trạng thái",
	"dialog.predicate_overrides.variants": "Biến đổi",
	"dialog.predicate_overrides.start_value": "Bắt đầu",
	"dialog.predicate_overrides.add_override": "Thêm ghi đè",
	"dialog.predicate_overrides.add_predicate": "Thêm điều kiện",
	"dialog.predicate_overrides.generate_overrides": "Tạo ghi đè",
	"dialog.predicate_overrides.confirm_delete": "Bạn có chắc chắn muốn xóa tất cả ghi đè không?",
	"dialog.predicate_overrides.predicate.angle": "Góc La Bàn",
	"dialog.predicate_overrides.predicate.blocking": "Bị chặn",
	"dialog.predicate_overrides.predicate.broken": "Bị hỏng",
	"dialog.predicate_overrides.predicate.cast": "Truyền",
	"dialog.predicate_overrides.predicate.cooldown": "Hồi",
	"dialog.predicate_overrides.predicate.damage": "Sát thương",
	"dialog.predicate_overrides.predicate.damaged": "Bị hư hại",
	"dialog.predicate_overrides.predicate.lefthanded": "Thuận tay trái",
	"dialog.predicate_overrides.predicate.pull": "Độ căng",
	"dialog.predicate_overrides.predicate.pulling": "Đang kéo",
	"dialog.predicate_overrides.predicate.charged": "Đã sạc",
	"dialog.predicate_overrides.predicate.firework": "Có pháo hoa",
	"dialog.predicate_overrides.predicate.throwing": "Sẵn sàng để ném",
	"dialog.predicate_overrides.predicate.time": "Thời gian trong ngày",
	"dialog.predicate_overrides.predicate.custom_model_data": "Dữ liệu mô hình tùy chỉnh",
	"dialog.predicate_overrides.predicate.level": "Mức độ ánh sáng",
	"dialog.predicate_overrides.predicate.filled": "Mức lấp đầy Túi bọc",
	"dialog.predicate_overrides.predicate.tooting": "Thổi sáo",
	"settings.model_export_scale": "Kích thước khẩu mô hình",
	"settings.model_export_scale.desc": "Yếu tố làm giảm quy mô của các mô hình glTF, DAE và FBX đã xuất. Giá trị mặc định là 16, chuyển đổi 16 đơn vị Blockbench thành 1 mét khi xuất.",
	"action.export_fbx": "Xuất mô hình FBX",
	"action.export_fbx.desc": "Xuất mô hình và hoạt ảnh dưới dạng tệp fbx để sử dụng nó trong các ứng dụng 3D và công cụ trò chơi khác",
	"action.center_lateral": "Phía trung tâm",
	"action.center_lateral.desc": "Căn giữa phần tử đã chọn trên trục X và Z",
	"action.adjust_opacity": "Điều chỉnh độ mờ...",
	"action.adjust_opacity.desc": "Điều chỉnh độ mờ của kết cấu đã chọn",
	"action.rotate_texture_cw": "Xoay kết cấu theo chiều kim đồng hồ",
	"action.rotate_texture_ccw": "Xoay kết cấu ngược chiều kim đồng hồ",
	"action.predicate_overrides": "Chỉnh sửa ghi đè vị ngữ...",
	"action.predicate_overrides.desc": "Chọn các mô hình để ghi đè mô hình này dựa trên các điều kiện đã chọn",
	"action.auto_set_cullfaces": "Đặt Cullfaces tự động",
	"action.auto_set_cullfaces.desc": "Tự động tạo các bề mặt trống để ẩn các mặt khi chúng bị che bởi khối lân cận.",
	"menu.texture.edit_externally": "Chỉnh sửa ngoài",
	"menu.mirror_painting.texture": "Trình chỉnh sửa 2D đối xứng",
	"menu.mirror_painting.texture.desc": "Cho phép vẽ phản chiếu trong không gian 2D trên hình ảnh hoặc kết cấu",
	"menu.animator.rotation_global": "Xoay trong không gian tổng thể",
	"uv_editor.face_properties": "Thuộc tính mặt",
	"uv_editor.face_properties.material_instance": "Trường hợp vật chất",
	"uv_editor.tint.info": "Bạn có thể yêu cầu Minecraft tô màu cho nó bằng cách bật tông màu trên bề mặt. Trong vanilla, sắc độ chỉ có thể được sử dụng trên một số khối nhất định, chẳng hạn như lá và bụi đá đỏ và chỉ có thể có giá trị bằng 0.",
	"uv_editor.cullface.info": "Kích hoạt tính năng loại bỏ mặt sau sẽ khiến bề mặt của khối không được hiển thị nếu một khối đầy đủ khác được đặt bên cạnh nó theo hướng đã chỉ định trong thế giới Minecraft. Bạn có thể sử dụng điều này để tối ưu hóa hiệu suất.",
	"uv_editor.material_instance.info": "Các phiên bản vật liệu có thể được đặt thành tên do người dùng xác định. Tên đó có thể được sử dụng trong tệp JSON của khối trong gói hành vi để chỉ định một kết cấu và chất liệu cụ thể mà bề mặt đó.",
	"display.reference.frame_invisible": "Khung vật phẩm (Vô hình)",
	"data.settings_profile": "Hồ sơ",
	"message.display_skin.invalid_name": "Không thể tìm thấy tài khoản Minecraft có tên \"%0\".",
	"dialog.load_plugins_from_query.title": "Tải plugin",
	"dialog.load_plugins_from_query.text": "Bạn đã sử dụng một liên kết yêu cầu cài đặt plugin. Bạn có muốn cài đặt chúng?",
	"dialog.select_model.title": "Chọn một mô hình",
	"dialog.select_model.bones": "Xương",
	"dialog.select_model.cubes": "Khối",
	"dialog.settings.create_profile": "Tạo hồ sơ...",
	"settings_profile.confirm_delete": "Bạn có chắc chắn muốn xóa cài đặt hồ sơ này không?",
	"settings_profile.condition.type.selectable": "Có thể chọn thủ công",
	"settings.interface_mode": "Chế độ UI",
	"settings.interface_mode.desc": "Chế độ giao diện. Khởi động lại Blockbench để áp dụng các thay đổi",
	"settings.interface_mode.auto": "Tự động",
	"settings.interface_mode.desktop": "Bản máy tính",
	"settings.interface_mode.mobile": "Bản di động",
	"settings.paint_through_transparency": "vẽ đằng sau các pixel trong suốt",
	"settings.paint_through_transparency.desc": "Vẽ qua các điểm ảnh trong suốt khi Khóa kênh Alpha được bật",
	"action.tab_overview": "Tổng quan về tab",
	"action.tab_overview.desc": "Xem tất cả các tab đang mở trong một lưới và chuyển đến một",
	"action.slider_color_red": "Màu đỏ",
	"action.slider_color_green": "Màu xanh lá",
	"action.slider_color_blue": "Màu xanh dương",
	"action.add_animation_controller": "Thêm bộ điều khiển hoạt ảnh",
	"action.add_animation_controller.desc": "Tạo bộ điều khiển hoạt ảnh trống",
	"action.animation_controller_preview_mode": "Xem trước bộ điều khiển",
	"action.animation_controller_preview_mode.paused": "Tạm ngừng",
	"action.animation_controller_preview_mode.manual": "Xem trước thủ công",
	"action.animation_controller_preview_mode.play": "Tự chạy",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Kết nối tay cầm Bézier",
	"action.keyframe_bezier_linked.desc": "Kết nối tay cầm bézier phải và trái của khung hình chính",
	"action.reset_keyframe_handles": "Đặt lại khung hình chính",
	"action.reset_keyframe_handles.desc": "Đặt lại các nút Bézier trên các khung hình chính đã chọn",
	"action.looped_animation_playback": "Phát lặp lại",
	"action.looped_animation_playback.desc": "Xem trước hoạt ảnh trong một vòng lặp vô hạn",
	"timeline.bind_to_actor": "Ràng buộc với người dùng",
	"animation_controllers.select_preset": "Chọn giá trị cài sẵn của bộ điều khiển...",
	"animation_controllers.state.animations": "Hoạt ảnh",
	"animation_controllers.state.particles": "Hạt",
	"animation_controllers.state.sounds": "Âm thanh",
	"animation_controllers.state.on_entry": "Khi vào",
	"animation_controllers.state.on_exit": "Khi thoát",
	"animation_controllers.state.transitions": "Chuyển tiếp",
	"animation_controllers.state.condition": "Tình trạng",
	"animation_controllers.state.blend_transition": "Pha trộn thời gian",
	"animation_controllers.state.shortest_path": "Trộn theo đường đi ngắn nhất",
	"animation_controllers.state.edit_transition": "Chỉnh sửa chuyển tiếp",
	"menu.color_picker.picker_type": "Loại bộ chọn",
	"menu.color_picker.picker_type.square": "Vuông",
	"menu.color_picker.picker_type.wheel": "Bánh",
	"menu.color_picker.slider_mode": "Thanh trượt",
	"menu.color_picker.slider_mode.hsv": "Tông màu, Độ bão hoà, Sắc độ",
	"menu.color_picker.slider_mode.rgb": "RPG",
	"menu.texture.render_mode.additive": "Thêm",
	"panel.color.picker_options": "Cài đặt thuốc nhỏ mắt",
	"panel.animation_controllers": "Trình điều khiển hoạt ảnh",
	"display.preset.armor_stand": "Sàn (Giá để giáp)",
	"data.file_path": "Đường dẫn tập tin",
	"dialog.extrude.orientation": "Định hướng",
	"dialog.extrude.orientation.upright": "Vuông góc",
	"dialog.extrude.orientation.flat": "Phẳng",
	"dialog.scale.box_uv_warning": "Mở rộng mô hình Box UV có thể phá vỡ UV của mô hình của bạn. Thay vào đó, hãy thử mở rộng mô hình của bạn ra bên ngoài hoặc chuyển sang Chế độ UV trên mỗi mặt trong Tệp > Dự án.",
	"dialog.create_gif.format": "Định dạng",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Trình tự PNG",
	"dialog.create_gif.pixelate": "Tạo điểm ảnh",
	"dialog.create_gif.bg_image": "Ảnh nền",
	"dialog.create_gif.turn.desc": "Xoay mô hình trong khi ghi. Sử dụng các giá trị âm để xoay mô hình theo chiều kim đồng hồ. Giá trị 60 tương ứng với một vòng quay mỗi giây.",
	"settings_profile.condition": "Tình trạng",
	"settings_profile.condition.type.file_path.desc": "So khớp đường dẫn tệp trong dự án hiện tại bằng cú pháp biểu thức chính quy. Sử dụng dấu gạch chéo lên trong đường dẫn tệp",
	"settings.only_selected_bezier_handles": "Chỉ hiển thị tay cầm Bézier đã chọn",
	"settings.only_selected_bezier_handles.desc": "Ẩn tay cầm của các khung hình chính Bézier hiện không được chọn",
	"settings.embed_textures": "Nhúng kết cấu",
	"settings.embed_textures.desc": "Nhúng nội dung tệp kết cấu vào tệp .bbmodel",
	"action.selection_mode.cluster": "Cụm",
	"dialog.copied_to_clipboard": "Đã sao chép vào bảng tạm",
	"data.reference_image": "Ảnh tham chiếu",
	"message.delete_reference_image": "Bạn có chắc chắn muốn xóa ảnh tham chiếu này không? Điều này không thể được hoàn tác.",
	"message.add_reference_image.message": "Chọn nơi tải ảnh tham chiếu",
	"message.add_reference_image.project": "Thêm vào dự án này",
	"message.add_reference_image.app": "Thêm vào tất cả các dự án",
	"message.import_particle_texture.import": "Nhập kết cấu hạt",
	"message.import_particle_texture.message": "Bạn có muốn nhập tệp kết cấu để sử dụng cho hạt của mình không?",
	"message.save_codec_selector.title": "Lưu định dạng mô hình",
	"message.save_codec_selector.message": "Chọn một định dạng để lưu mô hình.",
	"message.save_codec_selector.project_file": "Dự án Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Cả hai",
	"message.display_skin.username": "Tên người dùng (Java)",
	"message.palette_locked": "Bảng màu bị khóa",
	"dialog.project.default_uv_mode": "Chế độ UV mặc định",
	"dialog.project.default_uv_mode.description": "Chế độ UV mặc định của dự án. Chế độ UV cũng có thể được thay đổi trên mỗi khối.",
	"dialog.export_options.title": "Tùy chọn xuất",
	"dialog.edit_texture.preview": "Xem trước",
	"dialog.proportional_editing.range": "Phạm vi",
	"dialog.proportional_editing.falloff": "Suy thoái",
	"dialog.proportional_editing.falloff.linear": "Tuyến tính",
	"dialog.proportional_editing.falloff.hermite_spline": "Mịn màng",
	"dialog.proportional_editing.falloff.constant": "Hằng số",
	"dialog.proportional_editing.selection": "Lựa chọn",
	"dialog.proportional_editing.selection.linear": "Khoảng cách tuyến tính",
	"dialog.proportional_editing.selection.connections": "Các kết nối",
	"dialog.mirror_painting_texture_center.middle": "Ở giữa",
	"dialog.mirror_painting_texture_center.custom": "Tuỳ biến",
	"dialog.settings.reset_to_default": "Đặt lại về mặc định",
	"keybindings.item.num_slider.increase": "Tăng",
	"keybindings.item.num_slider.decrease": "Giảm bớt",
	"settings.always_show_splash_art": "Luôn hiển thị màn hình giật gân",
	"settings.always_show_splash_art.desc": "Luôn hiển thị màn hình giật gân trên màn hình bắt đầu",
	"action.slider_palette_color": "Chuyển đổi bảng màu",
	"action.slider_palette_color.desc": "Luân chuyển giữa các màu trong bảng màu",
	"action.proportional_editing": "Chỉnh sửa theo tỷ lệ",
	"action.proportional_editing.desc": "Ảnh hưởng đến các đỉnh xung quanh theo tỷ lệ khi chỉnh sửa các phần của lưới.",
	"action.limit_to_palette": "Giới hạn bảng màu",
	"action.limit_to_palette.desc": "Giới hạn màu kết cấu thành màu từ bảng màu được tải",
	"action.edit_reference_images": "Chỉnh sửa hình ảnh tham chiếu",
	"action.edit_reference_images.desc": "Bật chế độ hình ảnh tham chiếu để thêm hoặc chỉnh sửa hình ảnh tham chiếu và bản thiết kế",
	"action.add_reference_image": "Thêm ảnh tham chiếu",
	"action.reference_image_from_clipboard": "Ảnh tham chiếu từ bảng tạm",
	"action.reference_image_list": "Ảnh tham chiếu",
	"action.connect_uv_faces": "Kết nối mặt UV",
	"action.connect_uv_faces.desc": "Kết nối các mặt UV đã chọn với mặt UV được chọn cuối cùng",
	"action.merge_uv_vertices": "Hợp nhất các đỉnh UV",
	"action.merge_uv_vertices.desc": "Gắn các đỉnh UV được chọn đầu tiên vào các đỉnh UV được chọn cuối cùng",
	"action.bedrock_animation_mode": "Chế độ hoạt ảnh Bedrock",
	"action.bedrock_animation_mode.desc": "Chọn chế độ chỉnh sửa hoạt ảnh cho Minecraft: Bedrock Edition trong",
	"action.bedrock_animation_mode.entity": "Thực thể",
	"action.bedrock_animation_mode.attachable_first": "Mục cá thể 1",
	"action.bedrock_animation_mode.attachable_third": "Mục cá thể 3",
	"timeline.amplify": "Khuyếch đại",
	"menu.options": "Tùy chọn...",
	"menu.palette.lock_palette": "Khóa bảng màu",
	"menu.uv.export": "Xuất bản đồ UV",
	"menu.uv.flip_x": "Gương X",
	"menu.uv.flip_y": "Gương Y",
	"menu.mirror_painting.enabled": "Đã bật",
	"reference_image.position": "Vị trí",
	"reference_image.size": "Kích thước",
	"reference_image.rotation": "Xoay",
	"reference_image.opacity": "Độ trong suốt",
	"reference_image.visibility": "Ẩn",
	"reference_image.clear_mode": "Xóa chế độ",
	"reference_image.layer": "Lớp",
	"reference_image.layer.background": "Mô hình sau",
	"reference_image.layer.viewport": "Mô hình trên",
	"reference_image.layer.float": "Giao diện trên",
	"reference_image.scope": "Phạm vi",
	"reference_image.scope.project": "Chỉ dự án này",
	"reference_image.scope.global": "Tất cả dự án",
	"reference_image.enabled_modes": "Đã bật trong Chế độ",
	"codec.common.encoding": "Mã hóa",
	"codec.common.armature": "Xuất nhóm dưới dạng Bộ cốt",
	"codec.common.export_animations": "Xuất hoạt ảnh",
	"codec.common.embed_textures": "Nhúng kết cấu",
	"preview.center_camera": "Máy ảnh trung tâm",
	"display.reference.frame_top": "Khung vật phẩm trên",
	"display.reference.frame_top_invisible": "Khung vật phẩm trên (Vô hình)",
	"action.proportional_editing_range": "Phạm vi chỉnh sửa theo tỷ lệ",
	"action.proportional_editing_range.desc": "Điều chỉnh phạm vi để chỉnh sửa theo tỷ lệ",
	"action.toggle_all_reference_images": "Ẩn/Hiển thị tất cả ảnh tham chiếu",
	"action.toggle_all_reference_images.desc": "Chuyển đổi khả năng hiển thị của tất cả các hình ảnh tham chiếu cùng một lúc",
	"action.add_animation_controller_state": "Thêm Trạng thái Bộ điều khiển Hoạt ảnh",
	"action.add_animation_controller_state.desc": "Thêm một trạng thái mới vào bộ điều khiển hoạt ảnh",
	"menu.slider.round_value": "Giá trị tròn",
	"texture.error.too_large": "Độ phân giải vượt quá mức tối đa %0",
	"dialog.copy_to_clipboard": "Sao chép vào bảng tạm",
	"dialog.open_url": "Mở URL",
	"reference_image.image": "Hình ảnh",
	"uv_editor.rotate_uv": "Xoay UV",
	"generic.error": "Lỗi",
	"projects.start_screen": "Màn hình bắt đầu",
	"message.invalid_link.message": "Mô hình được chia sẻ \"%0\" mà bạn đang cố tải không hợp lệ hoặc đã hết hạn.",
	"message.plugin_dependencies.title": "Plugin phụ thuộc",
	"message.plugin_dependencies.message1": "Plugin yêu cầu các phụ thuộc này:",
	"message.plugin_dependencies.message1_update": "Plugin %0 đã được cập nhật và hiện yêu cầu các phụ thuộc sau:",
	"message.plugin_dependencies.message2": "Bạn có muốn cài chúng để tiếp tục không?",
	"message.plugin_dependencies.invalid": "Thật không may, plugin không thể cài đặt, nó có một phần phụ thuộc không hợp lệ:",
	"message.preview_scene_load_failed": "Không thể tải cảnh xem trước. Kiểm tra kết nối Internet của bạn.",
	"dialog.convert_project.text1": "Chuyển đổi dự án sang định dạng khác.",
	"dialog.convert_project.text2": "Sử dụng chuyển đổi rủi ro của riêng bạn. Các định dạng có các tính năng và hạn chế khác nhau, vì vậy, trong một số trường hợp, việc chuyển đổi sẽ làm hỏng các phần của dự án của bạn.",
	"dialog.convert_project.text3": "Bạn không thể hoàn tác chuyển đổi, đó là lý do tại sao một bản sao sẽ được tạo theo mặc định.",
	"dialog.unsaved_work.title": "Công việc chưa được lưu",
	"dialog.unsaved_work.text": "Các dự án sau chứa các thay đổi chưa được lưu. Bạn có muốn lưu các thay đổi của mình không?",
	"dialog.unsaved_work.discard_all": "Loại bỏ tất cả",
	"dialog.unsaved_work.save_all": "Lưu tất cả",
	"dialog.resize_texture.mode": "Chế độ",
	"dialog.resize_texture.mode.crop": "Cắt/Mở rộng",
	"dialog.resize_texture.mode.scale": "Tỉ lệ",
	"dialog.plugins.is_installed": "Cài đặt",
	"dialog.plugins.is_disabled": "Đã tắt",
	"dialog.plugins.disable": "Tắt",
	"dialog.plugins.enable": "Bật",
	"dialog.plugins.dependencies": "Phụ thuộc:",
	"dialog.view_backups.open_folder": "Mở thư mục",
	"dialog.share_model.reference_images": "Bao gồm hình ảnh tham khảo",
	"dialog.share_model.too_large": "Không thể tải lên: Mô hình quá lớn",
	"dialog.share_model.too_large_references": "Không thể tải lên: Mô hình quá lớn. Hãy thử mà không có hình ảnh tham khảo.",
	"settings.stretch_linked": "Giãn liên kết",
	"settings.stretch_linked.desc": "Kéo dài khối lập phương theo mọi hướng với cùng một giá trị",
	"settings.grids": "Hiện thị lưới",
	"settings.grids.desc": "Hiển hoặc ẩn tất cả lưới 3D",
	"settings.double_click_switch_tools": "Chuyển đổi công cụ khi nhấp đúp chuột",
	"settings.double_click_switch_tools.desc": "Nhấp đúp vào khung nhìn để chuyển đổi giữa các công cụ",
	"settings.outlines_in_paint_mode": "Lựa chọn đường viền trong Chế độ vẽ",
	"settings.outlines_in_paint_mode.desc": "Hiển thị lựa chọn đường viền phần tử trong khi ở chế độ vẽ",
	"settings.json_indentation": "Thụt lề JSON",
	"settings.json_indentation.desc": "Kiểu thụt đầu dòng cho các tệp JSON đã xuất",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Khoảng cách: 4",
	"settings.json_indentation.spaces_2": "Khoảng cách: 2",
	"action.slider_stretch": "Kéo dài",
	"action.slider_stretch.desc": "Kéo dài các khối theo cấp số nhân trên trục %0 mà không thay đổi UV",
	"action.view_backups": "Xem bản sao lưu",
	"action.view_backups.desc": "Duyệt qua danh sách các bản sao lưu dự án được lưu tự động",
	"action.search_outliner": "Tìm kiếm ngoài",
	"action.search_outliner.desc": "Tìm kiếm tên phần tử cụ thể trong phác thảo",
	"action.mirror_modeling": "Mô hình gương",
	"action.mirror_modeling.desc": "Bật Mô hình phản chiếu trên trục X. Tất cả các thay đổi bạn thực hiện trong chế độ xem sẽ được phản ánh sang phía bên kia, trừ khi được tắt cụ thể trên thành phần.",
	"action.allow_element_mirror_modeling": "Cho phép lập mô hình gương",
	"action.allow_element_mirror_modeling.desc": "Chọn xem các phần tử đã chọn có thể bị ảnh hưởng bởi mô hình gương hay không",
	"action.switch_face_crease": "Chuyển đổi nếp nhăn trên mặt",
	"action.switch_face_crease.desc": "Chuyển đổi theo hướng mà hình tứ giác gấp ở giữa",
	"action.clear_unused_texture_space": "Xóa không gian kết cấu không được sử dụng",
	"action.clear_unused_texture_space.desc": "Xóa các phần của kết cấu không được ánh xạ UV tới bất kỳ phần tử nào",
	"action.split_screen": "Chia đôi màn hình",
	"action.split_screen.desc": "Chọn chế độ chia màn hình khung nhìn",
	"action.split_screen.single": "Đơn",
	"action.split_screen.double_horizontal": "Đôi ngang",
	"action.split_screen.double_vertical": "Đôi dọc",
	"action.split_screen.quad": "Bốn",
	"action.split_screen.triple_left": "Ba trái",
	"action.split_screen.triple_right": "Ba phải",
	"action.split_screen.triple_top": "Ba trên",
	"action.split_screen.triple_bottom": "Ba dưới",
	"action.uv_project_from_view": "Dự án UV từ Chế độ xem",
	"action.uv_project_from_view.desc": "Tự động tạo UV cho các mặt đã chọn từ phối cảnh của chế độ xem 3D",
	"action.graph_editor_other_graphs": "Hiển thị đồ thị khác",
	"action.graph_editor_other_graphs.desc": "Biểu đồ đồ thị của các trục không được chọn có được hiển thị hay không",
	"action.graph_editor_include_other_graphs": "Bao gồm các đồ thị khác",
	"action.graph_editor_include_other_graphs.desc": "Trình chỉnh sửa biểu đồ có bao gồm các đồ thị không được chọn trong chế độ xem hay không",
	"action.set_ik_source": "Đặt gốc IK",
	"action.set_ik_source.desc": "Chọn xương gốc của chuỗi sẽ được di chuyển bởi đối tượng rỗng này thông qua Động học nghịch đảo",
	"edit.loop_cut.cuts": "Cắt",
	"panel.element.stretch": "Kéo dài",
	"preview_scene.minecraft_plains": "Đồng bằng",
	"preview_scene.minecraft_cherry_grove": "Rừng núi anh đào",
	"preview_scene.minecraft_snowy_tundra": "Đồng bằng băng tuyết",
	"preview_scene.minecraft_sunset": "Hoàng hôn",
	"preview_scene.minecraft_night": "Đêm",
	"preview_scene.minecraft_desert": "Sa mạc",
	"preview_scene.minecraft_underwater": "Dưới nước",
	"preview_scene.minecraft_coral_reef": "Rạn san hô",
	"preview_scene.minecraft_lush_cave": "Hang động tươi tốt",
	"preview_scene.minecraft_deep_dark": "Bóng tối sâu thẳm",
	"generic.navigate_forward": "Ở trước",
	"generic.navigate_back": "Trở lại",
	"action.element_render_order": "Thứ tự hiển thị độ trong suốt",
	"action.element_render_order.default": "Tự động",
	"action.element_render_order.behind": "Phía sau",
	"action.element_render_order.in_front": "Phía trước",
	"message.installing_update.title": "Cập nhật có sẵn",
	"message.installing_update.message": "Một phiên bản mới đã sẵn sàng để cài đặt. Sau khi đóng ứng dụng, vui lòng đợi khoảng %0 giây trước khi mở lại Blockbench hoặc tắt máy tính để cài đặt bản cập nhật.",
	"settings.brush_cursor_2d": "Con trỏ cọ vẽ 2D",
	"settings.brush_cursor_2d.desc": "Hiển thị đường viền xung quanh cọ vẽ trong môi trường 2D",
	"settings.brush_cursor_3d": "Con trỏ cọ vẽ 3D",
	"settings.brush_cursor_3d.desc": "Hiển thị đường viền xung quanh cọ vẽ trong môi trường 3D",
	"settings.cdn_mirror": "Dùng bản sao CDN",
	"settings.cdn_mirror.desc": "Dùng bản sao CDN để tải xuống các plugin. Máy bản sao nhận cập nhật nhanh hơn và hoạt động ở một số vùng mà mặc định không hoạt động.",
	"data.layer": "Lớp",
	"data.panel": "Bảng điều khiển",
	"generic.confirm_delete": "Bạn có chắc chắn muốn xóa thứ này không?",
	"format_category.general": "chung",
	"modifier_actions.no_uniform_scaling": "Tăng cỡ tự do",
	"message.texture_refresh_conflict.title": "Phiên bản kết cấu bị xung đột",
	"message.texture_refresh_conflict.message": "Tệp kết cấu có thể chứa các thay đổi xung đột với phiên bản của Blockbench.",
	"message.texture_refresh_conflict.keep_ours": "Giữ lại phiên bản của Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Tải tệp và loại bỏ tất cả các thay đổi và lớp trong Blockbench",
	"message.group_required_to_animate": "Bạn không thể tạo hiệu ứng chuyển động cho phần tử này. Hãy tạo một nhóm để tạo hiệu ứng chuyển động.",
	"dialog.texture.uv_size": "Kích cỡ UV",
	"dialog.advanced_screenshot.angle_preset": "Góc giá trị cài sẵn",
	"dialog.advanced_screenshot.resolution": "Độ phân giải",
	"dialog.advanced_screenshot.zoom_to_fit": "Thu phóng tới khi vừa",
	"dialog.advanced_screenshot.zoom": "Thu phóng / Tiêu cự",
	"dialog.advanced_screenshot.anti_aliasing": "Chống nhòe",
	"dialog.advanced_screenshot.anti_aliasing.off": "Tắt",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Lấy mẫu đa điểm",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Tăng mẫu siêu việt",
	"dialog.advanced_screenshot.show_gizmos": "Hiển thị chỉnh sửa Gizmos",
	"dialog.advanced_screenshot.shading": "Đổ bóng",
	"settings.auto_keyframe": "Khung hình chính tự động",
	"settings.auto_keyframe.desc": "Tự động tạo một khung hình chính với các giá trị mặc định tại thời điểm của dòng thời gian khi thay đổi thuộc tính của xương đó",
	"settings.modded_entity_integer_size": "Kích thước số nguyên thực thể sửa đổi",
	"settings.modded_entity_integer_size.desc": "Giới hạn kích thước khối trong định dạng thực thể sửa đổi thành số nguyên. Mặc dù định dạng dấu phẩy động được hỗ trợ theo kỹ thuật trong một số phiên bản, số nguyên dễ dàng hơn để ánh xạ UV",
	"category.layers": "Lớp",
	"keybind.paint_secondary_color": "Sơn với Màu Phụ",
	"action.selection_tool_operation_mode": "Lựa chọn chế độ hoạt động",
	"action.selection_tool_operation_mode.create": "Lựa chọn mới",
	"action.selection_tool_operation_mode.add": "Thêm vào lựa chọn",
	"action.selection_tool_operation_mode.subtract": "Trừ khỏi phần lựa chọn",
	"action.selection_tool_operation_mode.intersect": "Giao nhau",
	"action.pixel_perfect_drawing": "Vẽ hoàn hảo Pixel",
	"action.pixel_perfect_drawing.desc": "Vẽ các đường nghệ thuật pixel mượt mà không có pixel kép ở các đường cong",
	"action.selection_tool": "Công cụ lựa chọn",
	"action.selection_tool.desc": "Chọn các phần của hình ảnh",
	"action.selection_tool.rectangle": "Hình vuông",
	"action.selection_tool.ellipse": "Hình elip",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Đũa phép",
	"action.selection_tool.color": "Cùng màu",
	"action.move_layer_tool": "Di chuyển lớp",
	"action.move_layer_tool.desc": "Di chuyển lớp hoặc vùng chọn hiện tại",
	"action.export_modded_animations": "Xuất hoạt ảnh thực thể sửa đổi",
	"action.export_modded_animations.desc": "Xuất hoạt ảnh cho mô hình thực thể Minecraft phiên bản Java",
	"action.swap_colors": "Hoán đổi màu sắc",
	"action.swap_colors.desc": "Hoán đổi màu chính bằng màu phụ",
	"action.apply_mesh_rotation": "Áp dụng xoay",
	"action.apply_mesh_rotation.desc": "Đặt lại phần tử xoay của lưới và thay vào đó áp dụng nó cho hình học",
	"action.flip_texture_x.desc": "Lật kết cấu hoặc lớp theo chiều ngang",
	"action.flip_texture_y.desc": "Lật kết cấu hoặc lớp theo chiều dọc",
	"action.rotate_texture_cw.desc": "Xoay kết cấu hoặc lớp theo chiều kim đồng hồ",
	"action.rotate_texture_ccw.desc": "Xoay kết cấu hoặc lớp ngược chiều kim đồng hồ",
	"action.crop_texture_to_selection": "Cắt kết cấu thành vùng chọn",
	"action.create_empty_layer": "Tạo lớp trống",
	"action.enable_texture_layers": "Kích hoạt lớp",
	"action.disable_texture_layers": "Vô hiệu lớp",
	"action.layer_opacity": "Độ mờ của lớp",
	"action.layer_to_texture_size": "Mở rộng lớp sang kích thước kết cấu",
	"action.layer_to_texture_size.desc": "Mở rộng lớp theo kích thước của kết cấu",
	"action.merge_layer_down": "Hợp nhất xuống",
	"action.merge_layer_down.desc": "Hợp nhất vào lớp bên dưới",
	"action.advanced_screenshot": "Ảnh chụp màn hình nâng cao...",
	"action.advanced_screenshot.desc": "Chụp màn hình mô hình với các tùy chọn nâng cao",
	"action.bake_ik_animation": "Nướng giải tích nghịch đảo (IK)",
	"action.bake_ik_animation.desc": "Nướng các phép quay được áp dụng bởi động học nghịch đảo vào hoạt ảnh đã chọn",
	"action.save_animation_preset": "Lưu giá trị cài sẵn hoạt ảnh...",
	"action.save_animation_preset.desc": "Lưu các khung hình chính đã chọn làm giá trị cài sẵn hoạt ảnh",
	"action.animation_onion_skin": "Hoạt hoạ da Onion",
	"action.animation_onion_skin.desc": "Hiển thị chế độ xem khung dây của một khung khác trong hoạt ảnh để tham khảo",
	"action.apply_animation_preset": "Áp dụng giá trị cài sẵn hoạt ảnh",
	"action.apply_animation_preset.desc": "Chọn từ danh sách các giá trị cài sẵn hoạt ảnh và áp dụng nó cho xương đã chọn",
	"menu.brush_presets.pixel_perfect": "Cọ vẽ Pixel hoàn hảo",
	"panel.layers": "Lớp",
	"uv_editor.copy_paste_tool.to_layer": "Đến lớp mới",
	"format.image.new": "Tạo ảnh mới",
	"format.image.info.summary": "Trình chỉnh sửa ảnh 2D cho phép bạn tạo và chỉnh sửa hình ảnh cũng như ảnh nghệ thuật pixel trực tiếp trong Blockbench mà không cần tới trình chỉnh sửa hình ảnh bên ngoài. Chỉnh sửa hình ảnh, sửa đổi họa tiết hoặc tạo nghệ thuật pixel của riêng bạn!",
	"settings.move_with_selection_tool": "Sử dụng Công cụ lựa chọn để di chuyển các lựa chọn",
	"settings.move_with_selection_tool.desc": "Cho phép công cụ lựa chọn di chuyển trực tiếp các lựa chọn mà không cần phải chuyển sang công cụ di chuyển lớp",
	"settings.final_newline": "Dòng mới cuối cùng",
	"settings.final_newline.desc": "Chèn ký tự dòng mới vào cuối tệp đã xuất",
	"action.crop_layer_to_selection": "Cắt lớp để chọn",
	"action.edit_mode_uv_overlay.desc": "Hiển thị bản đồ UV dưới dạng lớp phủ trong chế độ chỉnh sửa",
	"menu.image": "Hình ảnh",
	"menu.texture.discard_changes": "Loại bỏ những thay đổi",
	"menu.texture.discard_changes.desc": "Hủy bỏ tất cả các thay đổi chưa được lưu và tải phiên bản mới nhất từ tệp",
	"panel.textures.images": "Hình ảnh",
	"dialog.advanced": "Nâng cao",
	"dialog.recommended_option": "Gợi ý",
	"modifier_actions.snap_to_center": "Nối vào Giữa",
	"modifier_actions.snap_to_pixels": "Nối vào các điểm ảnh",
	"message.invalid_format.install_plugin": "Tải plugin '%0'",
	"message.plugin_deprecated.message": "Bạn có chắc bạn muốn tải plugin không còn được dùng nữa hay không?",
	"message.plugin_deprecated.install_anyway": "Vẫn tải",
	"message.image_editor.not_found": "Không thể tìm thấy phần mềm chỉnh sửa ảnh đã chọn. Vui lòng chọn một phần mềm khác.",
	"message.knife_tool.confirm": "Nhấn phím %0 hoặc nhấn vào đây để áp dụng Công Cụ Dao",
	"message.knife_tool.skipped_face": "Không thể cắt giữa các mặt khác nhau. Hãy thêm các cạnh hoặc đỉnh giữa chúng!",
	"message.optimize_animation.keyframes_removed": "Đã xóa %0 khung hình chính thừa",
	"message.optimize_animation.nothing_to_optimize": "Không tìm thấy gì để tối ưu!",
	"message.duplicate_bone_copy_animation.title": "Sao chép hoạt ảnh",
	"message.duplicate_bone_copy_animation.message": "Phần xương được nhân bản chuyển động trong %0 hoạt hình. Bạn có muốn sao chép các khung hình chính qua cho phần xương mới?",
	"message.auto_fix_mesh_edit.title": "Tự sửa chữa",
	"message.auto_fix_mesh_edit.revert": "Hoàn tác chỉnh sửa",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Một số đỉnh đã bị di chuyển đến cùng một vị trí. Bạn muốn làm gì với điều đó?",
	"message.auto_fix_mesh_edit.concave_quads": "Một hoặc nhiều mặt bốn đã bị lõm xuống, có thể dẫn đến các vấn đề trong bản đồ UV và kết xuất. Blockbench có thể tự động sửa nó cho bạn:",
	"message.auto_fix_mesh_edit.merge_vertices": "Gộp các đỉnh lại",
	"message.auto_fix_mesh_edit.split_quads": "Tách các mặt bốn",
	"message.load_images.add_image": "Thêm ảnh",
	"dialog.project.modded_entity_entity_class": "Cấp Thực thể",
	"dialog.resize_texture.offset": "Bù lại",
	"dialog.animated_texture_editor.code_reference": "Mã tương quan",
	"dialog.animated_texture_editor.code_reference.about": "Cái mã để thực hiện hoạt ảnh kết cấu được tạo ra như là một tham khảo và không nhất thiết hoạt động mà không có sự thay đổi. Đọc tài liệu để biết thêm.",
	"dialog.animated_texture_editor.code_reference.docs": "Tài liệu",
	"dialog.animated_texture_editor.reframe": "Đóng khung lại",
	"dialog.animated_texture_editor.stride": "Kích thước khung",
	"dialog.animated_texture_editor.frames": "Số lượng khung",
	"dialog.animated_texture_editor.add_frame": "Thêm khung",
	"dialog.animated_texture_editor.resize_frames": "Chỉnh tỉ lệ khung lại...",
	"dialog.animated_texture_editor.apply": "Áp dụng",
	"dialog.add_primitive.edge_size": "Kích thước cạnh",
	"dialog.change_animation_speed.speed": "Tốc độ",
	"dialog.change_animation_speed.adjust_snapping": "Chỉnh sửa việc Nối",
	"dialog.optimize_animation.selection": "Lựa chọn",
	"dialog.optimize_animation.selection.selected_keyframes": "Khung hình chính được lựa chọn",
	"dialog.optimize_animation.selection.selected_animation": "Hoạt ảnh được lựa chọn",
	"dialog.optimize_animation.selection.all_animations": "Tất cả mọi hoạt hình",
	"dialog.optimize_animation.thresholds": "Ngưỡng các giá trị",
	"dialog.import_obj.obj": "Tệp OBJ",
	"dialog.import_obj.mtl": "Tệp MTL",
	"dialog.import_obj.scale": "Tỉ lệ",
	"layout.thumbnail": "Tùy chỉnh hình thu nhỏ CSS",
	"settings.pixel_grid": "Lưới điểm ảnh",
	"settings.pixel_grid.desc": "Hiển thị lưới đồ thị kết cấu điểm ảnh trên các phần tử trong chế độ chỉnh sửa",
	"settings.image_editor_grid_size": "Kích thước lưới đồ thị của công cụ chỉnh sửa ảnh",
	"settings.image_editor_grid_size.desc": "Kích thước lưới đồ thị lớn trong công cụ chỉnh sửa ảnh 2D",
	"settings.ground_plane_double_side": "Mặt phẳng sàn hai mặt",
	"settings.ground_plane_double_side.desc": "Làm mặt phẳng sàn nhìn thấy được từ phía dưới lên",
	"settings.optifine_save_default_texture": "OptiFine JEM: Xuất các kết cấu được chọn",
	"settings.optifine_save_default_texture.desc": "Xuất các kết cấu được chọn như là kết cấu mặc định của mô hình",
	"action.slider_color_select_threshold": "Ngưỡng chọn màu",
	"action.slider_color_select_threshold.desc": "Màu của điểm ảnh lân cận phải gần đến mức nào để được chọn theo màu hoặc theo cách chọn đũa phép",
	"action.stretch_tool": "Kéo giãn",
	"action.stretch_tool.desc": "Công cụ để chọn và kéo giãn các phần tử",
	"action.knife_tool": "Công cụ dao",
	"action.knife_tool.desc": "Công cụ để cắt các mặt khung lưới thành các miếng nhỏ hơn",
	"action.duplicate_project": "Nhân bản dự án",
	"action.duplicate_project.desc": "Tạo một bản sao của dự án",
	"action.transform_space.parent": "Gốc",
	"action.transform_pivot_space": "Tâm quay thay đổi không gian",
	"action.solidify_mesh_selection": "Làm đông đặc các mặt",
	"action.solidify_mesh_selection.desc": "Làm đông đặc các mặt được chọn của khung lưới",
	"action.animated_texture_editor": "Hoạt ảnh Sách lật...",
	"action.animated_texture_editor.desc": "Cài đặt hoặc chỉnh sửa hoạt ảnh sách lật của kết cấu được chọn",
	"action.center_individual_pivots": "Căn giữa tâm quay riêng lẻ",
	"action.center_individual_pivots.desc": "Đặt tâm quay của từng phần tử được chọn vào tâm của nó",
	"action.uv_cycle": "Tuần hoàn UV",
	"action.uv_cycle.desc": "Tuần hoàn qua thứ tự của các đỉnh UV mà không thay đổi vị trí của UV",
	"action.uv_cycle_invert": "Tuần hoàn UV ngược",
	"action.uv_cycle_invert.desc": "Tuần hoàn ngược qua thứ tự của các đỉnh UV mà không thay đổi vị trí của UV",
	"action.slider_animation_controller_speed": "Tốc độ phát lại bộ điều khiển",
	"action.slider_animation_controller_speed.desc": "Tốc độ phát lại của bộ điều khiển hoạt ảnh trên phần trăm",
	"action.optimize_animation": "Tối ưu hóa hoạt ảnh",
	"action.optimize_animation.desc": "Tối ưu hóa hoạt ảnh hiện tại và giảm số khung hình chính",
	"action.change_animation_speed": "Thay đổi tốc độ hoạt ảnh...",
	"action.change_animation_speed.desc": "Thay đổi tốc độ của hoạt ảnh được chọn",
	"timeline.select_particle_file": "Chọn tệp hạt",
	"timeline.select_sound_file": "Chọn tệp âm thanh",
	"menu.cube.texture.default": "Mặc định",
	"menu.texture.particle.clear": "Ngừng sử dụng cho các hạt",
	"menu.texture.use_as_default": "Đặt như mặc định",
	"menu.texture.use_as_default.clear": "Bỏ gán như mặc định",
	"menu.toolbar.overflow": "Thanh công cụ tràn",
	"edit.solidify_mesh_selection.thickness": "Độ dày",
	"reference_image.sync_to_timeline": "Đồng bộ với dòng thời gian",
	"reference_image.toggle_playback": "Bật/Tạm dừng",
	"dialog.add_primitive.shape.beveled_cuboid": "Khối bị vát",
	"dialog.ignore_all": "Bỏ qua hết",
	"data.texture_group": "Nhóm kết cấu",
	"data.animation": "Hoạt ảnh",
	"generic.on": "Bật",
	"generic.off": "Tắt",
	"format.free.info.3d_printing": "In 3D",
	"message.invalid_file.merge_conflict": "Tệp này chứa các xung đột hợp nhất Git chưa được giải quyết.",
	"dialog.expand_texture_selection.radius": "Số lượng",
	"dialog.expand_texture_selection.corner": "Hình dạng Góc",
	"dialog.expand_texture_selection.corner.round": "Tròn",
	"dialog.expand_texture_selection.corner.square": "Vuông",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Hợp nhất thành",
	"keybindings.variation_conflict": "Sự biến đổi xung đột với các phím tổ hợp chính",
	"settings.recovery_save_interval": "Quãng nghỉ điểm lưu phục hồi",
	"settings.recovery_save_interval.desc": "Blockbench thường xuyên lưu dự án đang mở trong nền để phục hồi trong trường hợp máy tính bị sập. Cài đặt quãng nghỉ bằng giây. Cài băng 0 để tắt việc lưu.",
	"settings.save_view_per_tab": "Lưu góc nhìn cho mỗi thẻ",
	"settings.save_view_per_tab.desc": "Lưu góc nhìn hiện tại cho mỗi thẻ riêng biệt",
	"settings.inherit_parent_color": "Thừa kế màu của phụ huynh",
	"settings.inherit_parent_color.desc": "Đặt màu đánh dấu của một phần tử mới tạo ra màu của phụ huynh thay vì một màu ngẫu nhiên",
	"keybind.preview_select.multi_select": "Chọn nhiều",
	"keybind.preview_select.group_select": "Chọn theo nhóm",
	"keybind.preview_select.loop_select": "Chọn lặp",
	"action.fill_mode.selection": "Lựa chọn",
	"action.fill_mode.selected_elements": "Phần tử được lựa chọn",
	"action.image_tiled_view": "Góc nhìn lát gạch",
	"action.image_tiled_view.description": "Kích hoạt nhìn lát gạch ",
	"action.image_onion_skin_view": "Da onion trong công cụ chỉnh sửa ảnh",
	"action.image_onion_skin_view.description": "Bật hiển thị chế độ da onion trong công cụ chỉnh sửa 2D",
	"action.expand_texture_selection": "Mở rộng lựa chọn kết cấu",
	"action.expand_texture_selection.desc": "Mở rộng hoặc thu lại lựa chọn kết cấu",
	"action.switch_tabs.reverse_order": "Đảo ngược thứ tự",
	"action.save_project_incremental": "Lưu dự án với Sự tăng",
	"action.save_project_incremental.desc": "Lưu mô hình hiện tại như một tệp dự án với một sự tăng (VD: project_2.bbmodel)",
	"action.copy.multiple": "Sao chép hết",
	"action.copy.multiple.desc": "Sao chép mọi dữ liệu đã có một cách riêng lẻ",
	"action.paste.multiple": "Dán hết",
	"action.randomize_marker_colors": "Ngẫu nhiên hóa màu của đánh dấu",
	"action.cube_light_emission": "Phát xạ ánh sáng",
	"action.cube_light_emission.desc": "Thay đổi sự phát xạ của các khối đã chọn, như một giá trị giữa 0 đến 15",
	"action.view_mode.colored_solid": "Chất rắn với màu đánh dấu",
	"action.focus_on_selection.rotate_only": "Chỉ xoay",
	"action.create_texture_group": "Tạo nhóm kết cấu",
	"action.create_texture_group.desc": "Tạo một nhóm cho những kết cấu của bạn",
	"action.uv_maximize.all_faces": "Ảnh hưởng đến mọi mặt",
	"action.retarget_animators": "Nhắm lại các hoạt ảnh",
	"action.retarget_animators.desc": "Lựa chọn hoạt ảnh nào nhắm vào xương hay phần tử nào",
	"action.merge_animation": "Hợp nhất hoạt ảnh",
	"action.merge_animation.desc": "Hợp hoạt ảnh với một hoạt ảnh khác",
	"action.add_keyframe.reset_values": "Với giá trị mặc định",
	"action.set_timeline_range_start": "Đặt bắt đầu phạm vi khung hình chính",
	"action.set_timeline_range_start.desc": "Đặt thời điểm bắt đầu cho một phạm vi phát lại được điều chỉnh trong khung hình chính hoạt ảnh",
	"action.set_timeline_range_end": "Đặt kết thúc phạm vi khung hình chính",
	"action.set_timeline_range_end.desc": "Đặt thời điểm kết thúc cho một phạm vi phát lại được điều chỉnh trong khung hình chính hoạt ảnh",
	"action.disable_timeline_range": "Tắt phạm vi khung hình chính",
	"action.disable_timeline_range.desc": "Tắt phạm vi phát lại được điều chỉnh trên khung hình chính hoạt ảnh",
	"menu.texture_group.resolve": "Giải quyết",
	"menu.image_tiled_view.mirrored": "Cạnh đã phản chiếu",
	"menu.image_onion_skin_view.frame": "Khung",
	"menu.image_onion_skin_view.frame.last_viewed": "Khung lần cuối được xem",
	"menu.image_onion_skin_view.frame.previous": "Khung trước đó",
	"menu.image_onion_skin_view.frame.next": "Khung tiếp theo",
	"menu.image_onion_skin_view.frame.both": "Trước đó + Tiếp theo",
	"menu.image_onion_skin_view.display": "Hiển thị",
	"menu.image_onion_skin_view.display.pixels": "Điểm ảnh nhỏ hơn",
	"menu.image_onion_skin_view.display.transparent": "Trong suốt",
	"menu.image_onion_skin_view.above": "Hiển thị ở trên",
	"menu.animation.reload": "Tải lại",
	"switches.autouv.alt": "Liên quan",
	"display.rotation_pivot": "Tâm quay xoay",
	"display.scale_pivot": "Tâm quay tỉ lệ",
	"display.reference.fox": "Cáo",
	"display.reference.eating": "Đang ăn",
	"preview_scene.sky": "Bầu trời",
	"preview_scene.space": "Không gian",
	"preview_scene.minecraft_ocean": "Biển",
	"message.import_palette.selection_only": "Chỉ được lựa chọn",
	"dialog.blend_transition_edit.ease_in_out": "Bắt đầu và kết thúc chậm (%0)",
	"dialog.blend_transition_edit.generate": "Tạo...",
	"dialog.blend_transition_edit.generate.learn_more": "Thông tin thêm và xem trước",
	"dialog.blend_transition_edit.generate.curve": "Loại hoạt hình",
	"dialog.blend_transition_edit.generate.steps": "Khung hình chính",
	"settings.fps_limit": "Giới hạn FPS",
	"settings.fps_limit.desc": "Giới hạn số khung mỗi giây mà Blockbench kết xuất. Số khung mỗi giây thực sự thì bị giới hạn bởi việc thiết bị của bạn có thể hiện thị cái gì.",
	"settings.outliner_reveal_on_select": "Tiết lộ các phần tử khi lựa chọn",
	"settings.outliner_reveal_on_select.desc": "Tiết lộ các phần tử trong bản sắp xếp khi được lựa chọn",
	"settings.java_export_pivots": "Xuất tâm quay trong các mô hình Java khối/vật phẩm",
	"settings.java_export_pivots.desc": "Lưu tâm quay trong mô hình Java khối/Vật phẩm trên các khối mà không xoay",
	"animation_controllers.state.blend_transition_curve": "Đường cong pha trộn chuyển tiếp",
	"menu.slider.reset_vector": "Đặt lại Véc tơ",
	"dialog.blend_transition_edit.extended": "Đồ thị được mở rộng",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGB Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGB channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}